const translations = {};

translations["MSG_GUIDE"] = "指南";
translations["MSG_NETWORK_ERROR_MESSAGE"] = "无法显示页面。\n请再试一次。";
translations["MSG_APP_ALL"] = "全部";
translations["MSG_APP_BANNER_TITLE"] = "乐学拼图 App";
translations["MSG_APP_BANNER_SUBTITLE"] = "~ 为孩子们打造的有趣编程教育 ~";
translations["MSG_APP_BANNER_INSTALL_BTN"] = "安装";
translations["MSG_APP_BANNER_SHOW_BTN"] = "显示";

translations["MSG_APP_VERSION_UPDATE_WARNING_TITLE"] = "正在将应用程序更新至最新版本。";
translations["MSG_APP_VERSION_UPDATE_WARNING_MESSAGE"] =
  "应用程序有新版本可用。\n需要更新才能使用最新功能。\n更新将很快完成。";
translations["MSG_APP_ERROR_PASSWORD_TOO_SHORT"] = "请输入 6 个字符或以上的密码。";
translations["MSG_APP_ERROR_PASSWORD_CONFIRM_NOT_VALID"] = "密码不匹配。";
translations["MSG_SIGN_IN_BTN"] = "登录";
translations["MSG_SIGN_UP_BTN"] = "注册";
translations["MSG_SIGN_IN_WITH_APPLE"] = "使用 Apple 继续";
translations["MSG_SIGN_UP_WITH_APPLE"] = "使用 Apple 继续";
translations["MSG_SIGN_IN_WITH_GOOGLE"] = "使用 Google 继续";
translations["MSG_SIGN_IN_WITH_MAIL"] = "使用电子邮件登录";
translations["MSG_SIGN_UP_WITH_MAIL"] = "使用电子邮件注册";
translations["MSG_SIGN_NO_ACCOUNT_REGISTER"] = "没有账户？注册";
translations["MSG_SIGN_ALREADY_ACCOUNT_LOGIN"] = "已有账户？登录";
translations["MSG_SIGN_PASSWORD_REQUIRED"] = "请输入密码";
translations["MSG_SIGN_LOGIN_FAILED"] = "登录失败。请检查您的电子邮件地址和密码。";
translations["MSG_SIGN_PASSWORD_MISMATCH"] = "密码不匹配";
translations["MSG_SIGN_UP_FAILED"] = "账户创建失败。请重试。";
translations["MSG_SIGN_EMAIL_REQUIRED"] = "请输入您的电子邮件地址";
translations["MSG_SIGN_EMAIL_INVALID"] = "请输入有效的电子邮件地址";
translations["MSG_SIGN_PASSWORD_RESET_FAILED"] = "密码重置邮件发送失败。请重试。";
translations["MSG_SIGN_PASSWORD_RESET_DESCRIPTION"] =
  "※我们将向您注册的电子邮件地址发送密码重置链接。";
translations["MSG_SIGN_PASSWORD_RESET_SEND_BTN"] = "发送重置邮件";
translations["MSG_SIGN_EMAIL_SENT"] = "邮件已发送";
translations["MSG_SIGN_PASSWORD_RESET_SENT"] = "密码重置链接已发送。\n请检查您的邮件。";
translations["MSG_SIGN_BACK_TO_LOGIN"] = "返回登录";
translations["MSG_USER_NAME_LENGTH_LIMIT"] = "请输入10个字符以内的姓名";
translations["MSG_USER_NAME_REQUIRED"] = "请输入姓名";
translations["MSG_USER_LATEST"] = "最新";
translations["MSG_USER_LIST"] = "用户列表";
translations["MSG_USER_START_LEARNING_MESSAGE"] = "为了开始学习，\n请先创建账户。";
translations["MSG_USER_ADD_CHILD_ACCOUNT"] = "添加儿童账户";
translations["MSG_USER_START"] = "开始";
translations["MSG_SIGN_USER_MAIL"] = "电子邮件地址";
translations["MSG_SIGN_USER_PASSWORD"] = "密码";
translations["MSG_SIGN_USER_PASSWORD_CONFIRM"] = "重新输入密码";
translations["MSG_SIGN_IN_SUCCESS_CONTENT"] = "登录成功。";
translations["MSG_SIGN_UP_SUCCESS_CONTENT"] = "账户注册成功。";
// ReAuth
translations["MSG_REAUTH_TITLE"] = "身份验证";
translations["MSG_REAUTH_SSO_MESSAGE"] = "请再次登录以继续";
translations["MSG_REAUTH_PASSWORD_RESET_CONFIRM"] = "将向以下邮箱发送密码重置邮件";
translations["MSG_REAUTH_BACK"] = "返回";
translations["MSG_BTN_LATER"] = "稍后";
translations["MSG_BTN_CLOSE"] = "关闭";

// Restricted Feature Dialog (统一版)
translations["MSG_RESTRICTED_FEATURE_TITLE_COURSE"] = "无法玩课程";
translations["MSG_RESTRICTED_FEATURE_TITLE_PROJECT_LIMIT"] = "无法制作应用";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_PROJECT_LIMIT"] =
  "「%{plan}」最多可创建%{limit}个应用。\n选择其他方案后可创建更多，<br>请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_CHILD_USER_LIMIT"] = "无法添加玩家";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_CHILD_USER_LIMIT"] =
  "「%{plan}」最多可添加%{limit}个用户。\n选择其他方案后可添加更多，<br>请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_CHAT_LIMIT"] = "无法发送消息";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_CHAT_LIMIT"] =
  "「%{plan}」每天可发送%{limit}次。\n选择其他方案后可发送更多，<br>请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_AI_IMAGE_LIMIT"] = "无法制作图像";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_AI_IMAGE_LIMIT"] =
  "「%{plan}」每天可制作%{limit}次。\n选择其他方案后可制作更多，<br>请询问家长。";
translations["MSG_RESTRICTED_FEATURE_TITLE_ASSET_LIMIT"] = "无法保存素材";
translations["MSG_RESTRICTED_FEATURE_MESSAGE_ASSET_LIMIT"] =
  "「%{plan}」最多可保存%{limit}的素材。\n选择其他方案后可保存更多，<br>请询问家长。";
translations["MSG_RESTRICTED_FEATURE_BTN_VIEW_PLANS"] = "选择方案";

// Upgrade Promotion
translations["MSG_UPGRADE_PROMOTION_TITLE"] = "升级你的计划，享受更多！";
translations["MSG_UPGRADE_MODAL_TITLE"] = "选择方案";
translations["MSG_UPGRADE_MODAL_SUBTITLE"] = "请根据孩子的使用情况选择合适的套餐";
translations["MSG_UPGRADE_MODAL_CURRENT_PLAN"] = "当前套餐";
translations["MSG_UPGRADE_PROMOTION_RECOMMENDED"] = "推荐";
translations["MSG_UPGRADE_PROMOTION_TABLE_PLAN"] = "计划";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS"] = "儿童用户数";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_TRIAL"] = "1人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_FREE"] = "2人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_STANDARD"] = "4人";
translations["MSG_UPGRADE_PROMOTION_TABLE_USERS_PREMIUM"] = "8人";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS"] = "作品数";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_TRIAL"] = "1个";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_FREE"] = "5个";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_STANDARD"] = "10个";
translations["MSG_UPGRADE_PROMOTION_TABLE_PROJECTS_PREMIUM"] = "10个";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE"] = "AI图像";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_TRIAL"] = "每天1次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_FREE"] = "每天2次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_STANDARD"] = "每天10次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_IMAGE_PREMIUM"] = "无限制\n（同时3张）";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT"] = "AI助手";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_TRIAL"] = "每天4次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_FREE"] = "每天8次";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_STANDARD"] = "无限制";
translations["MSG_UPGRADE_PROMOTION_TABLE_AI_CHAT_PREMIUM"] = "无限制";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE"] = "数据存储容量";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_TRIAL"] = "100MB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_FREE"] = "1GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_STANDARD"] = "5GB";
translations["MSG_UPGRADE_PROMOTION_TABLE_STORAGE_PREMIUM"] = "50GB";
translations["MSG_PLAN_CHANGE_BTN"] = "变更方案";
translations["MSG_UPGRADE_PROMOTION_CHANGE_BTN"] = "变更";
translations["MSG_UPGRADE_PROMOTION_TRIAL_DESCRIPTION"] = "注册账户后可订阅付费计划";
translations["MSG_UPGRADE_PROMOTION_FREE_DESCRIPTION"] = "您可以在家长页面更改计划";
translations["MSG_UPGRADE_PROMOTION_LATER_BTN"] = "稍后";
translations["MSG_UPGRADE_PROMOTION_SIGNUP_BTN"] = "注册账户";
translations["MSG_UPGRADE_PROMOTION_UPGRADE_BTN"] = "前往家长页面";
translations["MSG_UPGRADE_PROMOTION_BTN_REGISTER"] = "注册";
translations["MSG_UPGRADE_PROMOTION_BTN_PURCHASE"] = "购买";

translations["MSG_SIGN_IN_FAILED_TITLE"] = "登录失败";
translations["MSG_SIGN_IN_FAILED_MESSAGE"] = "电子邮件地址或密码不正确。";
translations["MSG_SIGN_IN_FORGOT_PASSWORD"] = "忘记密码？";
translations["MSG_SIGN_IN_FORGOT_PASSWORD_TITLE"] = "重置密码";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_CURRENT_PASSWORD"] = "当前密码";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD"] = "新密码";
translations["MSG_SIGN_CHANGE_PASSWORD_LABEL_NEW_PASSWORD_CONFIRM"] = "确认密码";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_SUCCESS_CONTENT"] = "密码更改成功。";
translations["MSG_SIGN_IN_CHANGE_PASSWORD_CURRENT_PASSWORD_WRONG"] = "输入的密码不正确。";
translations["MSG_SIGN_UP_EMAIL_ALREADY_EXISTS_FAILED_MESSAGE"] = "此电子邮件地址已被使用。";
translations["MSG_PARENTS_PROFILE_DEFAULT_NAME"] = "家长";

translations["MSG_DATETIME_PERIOD"] = "期间";
translations["MSG_DATETIME_PERIOD_RECENTLY"] = "最近";
// 中国大陆常用格式
translations["MSG_DATETIME_FORMAT_HOUR"] = "时";
translations["MSG_DATETIME_FORMAT_MINUTE"] = "分";

translations["MSG_INEXUS_OFFICIAL"] = "乐学拼图";
translations["MSG_INEXUS_OFFICIAL_CONTACT"] = "樂學拼圖 支持";
translations["MSG_AI_CHAT_SESSION_START"] = "新的对话";
translations["MSG_AI_CHAT_SESSION_END"] = "对话结束";
translations["MSG_REVIEW_RATING_TITLE"] = "请评价\n'乐学拼图'！";
translations["MSG_REVIEW_FEEDBACK_TITLE"] = "意见箱";
translations["MSG_REVIEW_SEND_RATING_CONFIRM"] = "发送";
translations["MSG_REVIEW_SEND_FEEDBACK_CONFIRM"] = "发送意见反馈";
translations["MSG_REVIEW_THANKS_BUBBLE_TEXT"] = "非常\n感谢您！";
translations["MSG_REVIEW_FEEDBACK_THANKS_TEXT"] = "我们期待您继续支持\n'乐学拼图'。";

translations["MSG_REVIEW_FEEDBACK_TYPE_APP"] = "整个应用程序";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE"] = "'通过课程学习'";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR"] = "'自由创作'";
translations["MSG_REVIEW_FEEDBACK_TYPE_NONE"] = "没有抱怨";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HOW_TO_USE"] = "不知道\n如何使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_APP_HARD_TO_USE"] = "难以使用";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_DIFFICULT"] = "太难";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_EASY"] = "太简单";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_MANY"] = "关卡\n太多";
translations["MSG_REVIEW_FEEDBACK_TYPE_COURSE_TOO_FEW"] = "关卡\n太少";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_CREATE"] = "无法\n顺利创作";
translations["MSG_REVIEW_FEEDBACK_TYPE_CREATOR_HARD_TO_USE"] = "难以\n使用";
translations["MSG_REVIEW_FEEDBACK_PLACEHOLDER"] = "在此自由填写";
translations["MSG_USER_PROFILE_ADD_USER_BTN"] = "添加";
translations["MSG_USER_PROFILE_CHANGE_USER"] = "切换用户";
translations["MSG_USER_PROFILE_CHANGE_USER_TITLE"] = "切换用户？";
translations["MSG_USER_PROFILE_CHANGE_USER_MESSAGE"] = "切换到「%{name}」。";
translations["MSG_USER_PROFILE_CHANGE_USER_SUCCESS"] = "已切换用户。";
translations["MSG_USER_PROFILE_CHANGE_USER_FAILED"] = "切换用户失败。";
translations["MSG_USER_PROFILE_MAX_USER_TITLE"] = "无法添加用户";
translations["MSG_USER_PROFILE_MAX_USER_MESSAGE"] =
  "当前方案最多可创建%{limit}个用户\n如需添加新用户，请删除已有用户";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_TITLE"] = "这里无法添加";
translations["MSG_USER_PROFILE_ADD_USER_DISABLED_MESSAGE"] =
  "・只有家长才能添加玩家。\n・如需添加玩家，请让家长在家长页面进行添加。";
translations["MSG_USER_PROFILE_SHOW_USER_LIST_BTN"] = "更多";
translations["MSG_USER_PROFILE_USER_STATUS"] = "状态";
translations["MSG_USER_SELECTION_PROMPT"] = "请选择玩家";
translations["MSG_USER_PROFILE_DEFAULT_NAME"] = "姓名%{random}";
translations["MSG_USER_PROFILE_FIELD_NAME"] = "昵称";
translations["MSG_USER_PROFILE_FIELD_NAME_PLACEHOLDER"] = "输入昵称";
translations["MSG_USER_PROFILE_FIELD_GENDER"] = "性别";
translations["MSG_USER_PROFILE_FIELD_GENDER_MALE"] = "男性";
translations["MSG_USER_PROFILE_FIELD_GENDER_FEMALE"] = "女性";
translations["MSG_USER_PROFILE_FIELD_GENDER_NONE"] = "无";
translations["MSG_USER_PROFILE_FIELD_BIRTHDAY"] = "生日";
translations["MSG_USER_PROFILE_STATUS_COURSE_CLEARED"] = "已完成\n课程";
translations["MSG_USER_PROFILE_STATUS_PROJECTS"] = "已创建\n应用程序";
translations["MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS"] = "已发布\n应用程序";
translations["MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE"] = "收到的\n赞数";
translations["MSG_USER_PROFILE_STATUS_DAYS_SINCE_JOIN"] = "加入\n天数";
translations["MSG_USER_PROFILE_STATUS_DAYS_UNIT"] = "%{count}天";
translations["MSG_USER_PROFILE_STATUS_PLAN"] = "套餐";
translations["MSG_USER_TAB_PROGRESS"] = "学习";
translations["MSG_USER_TAB_STOCK"] = "物品";
translations["MSG_USER_TAB_PLAN"] = "方案";
translations["MSG_USER_PLAN_CURRENT"] = "使用中";
translations["MSG_USER_PLAN_USAGE"] = "使用量";
translations["MSG_USER_PLAN_CHANGE"] = "更改方案";
translations["MSG_USER_PLAN_PROJECTS"] = "作品数量";
translations["MSG_USER_PLAN_AI_CHAT"] = "AI聊天";
translations["MSG_USER_PLAN_AI_IMAGE"] = "AI图像";
translations["MSG_USER_PLAN_UNLIMITED"] = "无限制";
translations["MSG_USER_PLAN_HERO_INCLUDED"] = "方案包含的内容";
translations["MSG_USER_PLAN_HERO_TAGLINE_TRIAL"] = "试试看吧！";
translations["MSG_USER_PLAN_HERO_TAGLINE_FREE"] = "免费玩";
translations["MSG_USER_PLAN_HERO_TAGLINE_STANDARD"] = "制作更多";
translations["MSG_USER_PLAN_HERO_TAGLINE_PREMIUM"] = "创作无限！";
translations["MSG_USER_PLAN_HERO_TAGLINE_BUILDER"] = "还能制作地图！";
translations["MSG_USER_PLAN_HERO_TAGLINE_EDUCATION"] = "一起学习";
translations["MSG_USER_PLAN_UPGRADE_CARD_TITLE"] = "还有更多有趣的方案";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NOW"] = "现在";
translations["MSG_USER_PLAN_UPGRADE_COMPARE_HEADER_NEXT"] = "升级后";
translations["MSG_USER_PLAN_BILLING_MONTHLY"] = "按月";
translations["MSG_USER_PLAN_BILLING_ANNUAL"] = "按年";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL"] = "省2个月！";
translations["MSG_USER_PLAN_BILLING_ANNUAL_DEAL_BADGE"] = "省2个月！";
translations["MSG_USER_PLAN_PRICE_PER_MONTH"] = "/月";
translations["MSG_USER_PLAN_PRICE_PER_YEAR"] = "/年";
translations["MSG_USER_PLAN_UPGRADE_BTN"] = "立即升级";
translations["MSG_USER_PLAN_VIEW_ALL_PLANS"] = "查看全部方案";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_TITLE"] = "需要更新应用";
translations["MSG_USER_PLAN_UPDATE_REQUIRED_MESSAGE"] = "请升级到最新版本";
translations["MSG_USER_PLAN_PURCHASE_SUCCESS"] = "升级成功！";
translations["MSG_USER_PLAN_PURCHASE_ERROR"] = "出错了，请再试一次";
translations["MSG_USER_PLAN_AI_IMAGE_PER_REQUEST"] = "1次生成";
translations["MSG_USER_PLAN_AI_IMAGE_CREATE_COUNT"] = "生成次数";
translations["MSG_USER_PLAN_AI_IMAGE_SIMULTANEOUS_COUNT"] = "单次张数";
translations["MSG_USER_PLAN_ASSETS"] = "存储空间";
translations["MSG_USER_PLAN_SUBTAB_CURRENT"] = "使用\n情况";
translations["MSG_USER_PLAN_SUBTAB_PURCHASE"] = "购买\n方案";
translations["MSG_USER_PLAN_COMPARE_HEADER_CURRENT"] = "当前";
translations["MSG_USER_PLAN_INACTIVE_NOTICE"] = "可以使用所有功能！";
translations["MSG_USER_PLAN_CARD_CURRENT_BADGE"] = "当前方案";
translations["MSG_USER_PLAN_PRICE_FREE"] = "¥0";
translations["MSG_USER_PLAN_GOTO_PURCHASE"] = "升级方案";
translations["MSG_USER_PLAN_BUY_BTN"] = "选择此方案";
translations["MSG_USER_PLAN_REGISTER_BTN"] = "注册";
translations["MSG_USER_PLAN_COMPARE_SAME"] = "相同";
translations["MSG_USER_PLAN_COMPARE_UNLOCK"] = "可以使用！";
translations["MSG_USER_PLAN_TIMES_SUFFIX"] = "倍";
translations["MSG_USER_PLAN_USAGE_CARD_TITLE"] = "使用状况";
translations["MSG_USER_PLAN_USAGE_CARD_SUBTITLE"] = "今日使用情况";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_TITLE"] = "升级后";
translations["MSG_USER_PLAN_UPGRADE_PREVIEW_SUBTITLE"] = "可以做更多的事情！";
translations["MSG_USER_PLAN_UNIT_PIECES"] = "个";
translations["MSG_USER_PLAN_UNIT_TIMES"] = "次";
translations["MSG_USER_PLAN_UNIT_SHEETS"] = "张";
translations["MSG_USER_PLAN_PERIOD_DAILY"] = "每日";
translations["MSG_USER_PROFILE_PROGRESS"] = "记录";
translations["MSG_USER_PROFILE_PROGRESS_NEW_TITLE"] = "新！";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_LEVEL_TITLE"] = "等级";
translations["MSG_USER_PROFILE_PROGRESS_COURSE"] = "通过课程\n学习";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_BTN"] = "已通关\n课程";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CHART_DATE_TITLE"] = "天";
translations["MSG_USER_PROFILE_PROGRESS_COURSE_CLEARED_TITLE"] = "已完成数量";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR"] = "自由\n创作";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_BTN"] = "我的\n作品";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_START"] = "总计";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_VIEW_TITLE_END"] = "人";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_START"] = "总计";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_CHART_FAVORITED_TITLE_END"] = "赞";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_VIEWED_TITLE"] = "访客";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_FAVORITED_TITLE"] = "赞数";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY"] = "还没有作品";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_PROJECT_EMPTY_DESC"] =
  "在「自由创作」中玩耍后，这里会显示";
translations["MSG_USER_PROFILE_PROGRESS_CREATOR_GOTO_BTN"] = "前往「自由创作」";
translations["MSG_USER_PROFILE_INFO"] = "我";
translations["MSG_USER_PROFILE_ICON_BTN"] = "更改图标";
translations["MSG_USER_PROFILE_CASE_BTN"] = "更改外壳";
translations["MSG_USER_PROFILE_STOCK"] = "素材";
translations["MSG_USER_PROFILE_SETTING"] = "设置";
translations["MSG_USER_PROFILE_NAME_ERROR_TITLE"] = "注册失败。";
translations["MSG_USER_PROFILE_NAME_ERROR_MESSAGE"] = "包含无法使用的字符或文本。请再试一次。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_TITLE"] = "注册失败。";
translations["MSG_PARENTS_USER_PROFILE_NAME_ERROR_MESSAGE"] =
  "包含无法使用的字符或文本。请再试一次。";
translations["MSG_USER_PROFILE_MESSAGE"] = "邮件";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_TITLE"] = "%{type} 询问";
translations["MSG_USER_PROFILE_MESSAGE_REPORT_TITLE"] = "向运营的报告";
translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"] =
  "感谢您的询问！\n请在下方的输入字段中填写您的问题。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_INPUT_AUTO_REPLY"] =
  translations["MSG_USER_PROFILE_MESSAGE_CONTACT_INPUT_AUTO_REPLY"];
translations["MSG_USER_PROFILE_MESSAGE_PARENTS_TALK_WELCOME_TEXT"] = " 加入了。";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_SEND_BTN"] = "发送";
translations["MSG_USER_PROFILE_MESSAGE_MENU"] = "菜单";

// Official welcome messages (dynamic index 0..3)
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_0"] = "%{name}，欢迎来到 '乐学拼图'！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_1"] =
  "在'乐学拼图'中，您可以边玩有趣的拼图边学习编程。\n首先，请从「通过课程学习」开始，依次学习如何游玩和学习！";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_2"] =
  "当您大致了解算法和编程方法后，请尝试在「自由创作」中随心所欲地创建您自己的应用程序。";
translations["MSG_USER_PROFILE_MESSAGE_OFFICIAL_WELCOME_TEXT_3"] = "来试试 '乐学拼图' 吧！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING"] = " 发送了评价。";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_RATING_AUTO_REPLY"] = "感谢您的评价！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_AUTO_REPLY"] = "感谢您的意见反馈！";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TITLE"] = "意见反馈";
translations["MSG_USER_PROFILE_MESSAGE_REVIEW_FEEDBACK_TYPE_OTHER"] = "・自我介绍：";
translations["MSG_USER_PROFILE_MESSAGE_CHAT_PLACEHOLDER"] = "在此自由填写";
translations["MSG_USER_PROFILE_MESSAGE_PUBLISHED_PROJECT_MESSAGE"] = '已发布应用程序 "%{name}"。';

translations["MSG_USER_DASHBOARD_TITLE"] = "仪表板";
translations["MSG_USER_DASHBOARD_VIEW_FULL_PAGE"] = "打开\n我的页面";
translations["MSG_USER_DASHBOARD_UNREAD"] = "未读";
translations["MSG_USER_DASHBOARD_NO_UNREAD"] = "没有新消息";
translations["MSG_DASHBOARD_SWITCH_PLAYER"] = "切换\n玩家";
translations["MSG_DASHBOARD_ADD_PLAYER"] = "添加\n玩家";
translations["MSG_DASHBOARD_CHANGE_PLAN"] = "变更\n方案";
translations["MSG_DASHBOARD_PLAN_USAGE_TITLE"] = "使用情况";
translations["MSG_DASHBOARD_QUICK_SETTINGS_TITLE"] = "快速设置";
translations["MSG_DASHBOARD_SETTING_LANGUAGE"] = "语言";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_CHAT"] = "AI聊天";
translations["MSG_DASHBOARD_PLAN_USAGE_AI_IMAGE"] = "AI图片";
translations["MSG_DASHBOARD_PLAN_USAGE_PROJECTS"] = "作品";
translations["MSG_DASHBOARD_PLAN_USAGE_STORAGE"] = "存储空间";

translations["MSG_TOP_TUTORIAL_FIRST_WELCOME_MESSAGE"] = "如果是第一次\n请观看教程！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_1"] = "今天也一起\n加油吧！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_2"] = "一起快乐地\n用拼图学习吧！";
translations["MSG_TOP_TUTORIAL_WELCOME_MESSAGE_3"] = "和我一起\n学习编程吧！";
translations["MSG_TOP_TUTORIAL_APP_START"] = "开始";
translations["MSG_TOP_TUTORIAL_START"] = "观看教程";
translations["MSG_TOP_TUTORIAL_DONOT_SHOW"] = "下次不再显示";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_1"] = "关于 '乐学拼图'";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_2"] = "关于「通过课程学习」";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_3"] = "关于「自由创作」";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_4"] = "帮助按钮与\n我的页面";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_5"] = "关于家长\n专用菜单";
translations["MSG_TOP_TUTORIAL_STEP_TITLE_6"] = "进行应用程序\n设置";
translations["MSG_TOP_TUTORIAL_CLOSE_PAGE"] = "关闭此屏幕";
translations["MSG_TOP_TUTORIAL_NEXT_PAGE"] = "下一步";
translations["MSG_TOP_TUTORIAL_START_APP"] = "开始 '乐学拼图'";
translations["MSG_ONBOARDING_PARENT_START"] = "开始拼图";
translations["MSG_ONBOARDING_PARENT_START_SUB"] = "新用户需要家长注册\n想接续数据游玩请从这里登录";
translations["MSG_ONBOARDING_SELF_START"] = "先试试";
translations["MSG_ONBOARDING_SELF_START_SUB"] = "无需注册即可体验";

// AuthSelection
translations["MSG_AUTH_SELECTION_INSTRUCTION"] = "已有账户请「登录」，首次使用请「注册」。";
translations["MSG_AUTH_SIGN_IN"] = "登录";
translations["MSG_AUTH_SIGN_IN_DESC"] = "使用现有账户登录";
translations["MSG_AUTH_SIGN_UP"] = "注册";
translations["MSG_AUTH_SIGN_UP_DESC"] = "创建新账户";
translations["MSG_NOTIFICATION_DEFAULT_TITLE"] = "通知";

translations["MSG_TRIAL_NOTICE_TITLE"] = "体验期即将结束！";
translations["MSG_TRIAL_NOTICE_BODY"] = "完成监护人注册后，可以玩得更多、做得更多。";
translations["MSG_TRIAL_NOTICE_FOR_KIDS"] = "如需继续使用，请注册监护人。";
translations["MSG_TRIAL_NOTICE_NOTE_FREE"] = "监护人注册免费。";
translations["MSG_TRIAL_NOTICE_CTA"] = "前往监护人注册";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA_HINT"] = "如需继续使用，请前往「监护设置」。";
translations["MSG_PARENT_REGISTRATION_PROMPT_CTA"] = "监护设置";
translations["MSG_GUEST_PURCHASE_OVERLAY_HINT"] = "请前往「监护设置」";

translations["MSG_BACK_BTN"] = "返回";
translations["MSG_HOME_BTN"] = "首页";
translations["MSG_CLOSE_BTN"] = "关闭";
translations["MSG_CANCEL_BTN"] = "取消";
translations["MSG_NEXT_BTN"] = "下一步";
translations["MSG_GENERATE_BTN"] = "生成";
translations["MSG_CONFIRM_BTN"] = "确定";
translations["MSG_SAVE_BTN"] = "保存";
translations["MSG_STOP_BTN"] = "停止";
translations["MSG_DELETE_BTN"] = "删除";
translations["MSG_PARENTS_CANCEL_BTN"] = "取消";
translations["MSG_PARENTS_CONFIRM_BTN"] = "确定";
translations["MSG_PARENTS_DELETE_BTN"] = "删除";
translations["MSG_ERROR_RELOAD_BTN"] = "重试";
translations["MSG_ERROR_TITLE"] = "无法正确完成处理。";
translations["MSG_ERROR_MESSAGE"] = "请再试一次。\n如果重试后仍然出现此屏幕，请咨询家长。";
// 中国大陆常用格式

translations["MSG_TOAST_FAILED"] = "失败";
translations["MSG_TOAST_SEND_FAILED"] = "发送失败";
translations["MSG_TOAST_EDIT_SUCCESS"] = "更改成功";
translations["MSG_TOAST_DELETED_SUCCESS"] = "删除成功";
translations["MSG_TOAST_PUBLISHED_SUCCESS"] = "发布成功";
translations["MSG_TOAST_DISABLE_PUBLISHED_SUCCESS"] = "取消发布成功";
translations["MSG_TOAST_ENABLE_COPIED_SUCCESS"] = "允许复制";
translations["MSG_TOAST_DISABLE_COPIED_SUCCESS"] = "禁止复制";
translations["MSG_TOAST_RESTORE_SUCCESS"] = "已还原应用程序";
translations["MSG_TOAST_COPY"] = "已复制。";
translations["MSG_TOAST_PAST"] = "已粘贴。";
translations["MSG_TOAST_UNDO"] = "已撤销。";
translations["MSG_TOAST_REDO"] = "已重做。";
translations["MSG_TOAST_INSERT_ASSET_IMAGE_SUCCESS"] = "已添加图片。";
translations["MSG_TOAST_INSERT_ASSET_TEMPLATE_SUCCESS"] = "已添加模板。";
translations["MSG_TOAST_CONTACT_SEND"] = "已发送询问。";
translations["MSG_SETTING_TOP_TUTORIAL"] = "应用程序启动屏幕";
translations["MSG_SETTING_TOP_TUTORIAL_SHOW"] = "启动时显示";
translations["MSG_SETTING_TOP_TUTORIAL_NOT_SHOW"] = "不显示";
translations["MSG_SETTING_APP_LANGUAGE"] = "应用程序显示语言";
translations["MSG_SETTING_SOUND"] = "音效";
translations["MSG_SETTING_BGM"] = "音乐";
translations["MSG_SETTING_PARENT_GATE"] = "监护设置";
translations["MSG_SETTING_GO_TO_TOP"] = "首页";
translations["MSG_SETTING_GO_TO_CONTACT"] = "联系我们";
translations["MSG_SETTING_GO_TO_REVIEW"] = "评价应用程序";
translations["MSG_SETTING_GO_TO_ASSISTANT"] = "和学伴君聊天";
translations["MSG_ASSISTANT_NAME"] = "学伴君";
translations["MSG_ASSISTANT_STATUS"] = "可以聊天哦！";
translations["MSG_ASSISTANT_YOU"] = "你";
translations["MSG_ASSISTANT_PLACEHOLDER"] = "输入消息...";
translations["MSG_ASSISTANT_SEND"] = "发送";
translations["MSG_ASSISTANT_STOP"] = "停止";
translations["MSG_ASSISTANT_GREETING"] = "%{name}，你好！\n我是学伴君。\n有什么问题吗？";
translations["MSG_ASSISTANT_USAGE_COUNT"] = "今天 %{remaining}/%{limit}次";
translations["MSG_ASSISTANT_EDUCATION_UNAVAILABLE"] = "教室方案无法与学伴君聊天";
translations["MSG_ASSISTANT_PARENT_NOT_ALLOWED"] = "家长没有允许使用这个功能";
translations["MSG_ASSISTANT_SELECT_IMAGE"] = "选择照片";
translations["MSG_ASSISTANT_TAB_ALBUM"] = "相册";
translations["MSG_ASSISTANT_TAB_DRAWING"] = "绘画";
translations["MSG_ASSISTANT_TAB_AI"] = "AI创作";
translations["MSG_ASSISTANT_STAMP_TAB"] = "贴图";
translations["MSG_ASSISTANT_LIMIT_REACHED"] = "今天的聊天结束了！明天见！";
translations["MSG_ASSISTANT_NEW_CHAT"] = "新对话";
translations["MSG_ASSISTANT_UPGRADE_BTN"] = "增加次数";
translations["MSG_ASSISTANT_AI_ERROR"] = "现在无法回复，请稍等一下再试一次！";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_TITLE"] = "从头开始！";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_MESSAGE"] =
  "重新开始对话\n换个话题也没问题\n随时可以轻松开始";
translations["MSG_ASSISTANT_NEW_CHAT_CONFIRM_BTN"] = "开始对话";
translations["MSG_SETTING_CLOSE_BTN"] = "关闭此屏幕";
translations["MSG_SETTING_TITLE_COURSE_ANSWER"] = "查看课程答案";
translations["MSG_SETTING_TITLE_CORPORATE_AUTH"] = "企业合作认证";
translations["MSG_SETTING_FOOTER_GO_TO_SITE"] = "前往 '乐学拼图' 网站";
translations["MSG_SETTING_FOOTER_TERMS_OF_SERVICE"] = "服务条款";
translations["MSG_SETTING_FOOTER_PRIVACY_POLICY"] = "隐私政策";
translations["MSG_SETTING_FOOTER_INQUIRY"] = "联系我们";
// 使用计数示例
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_TITLE"] = "恢复游玩";
translations["MSG_SETTING_PARENTS_ENABLE_KIDS_USER_MESSAGE"] = "恢复此用户的游玩。";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_TITLE"] = "暂停游玩";
translations["MSG_SETTING_PARENTS_DISABLE_KIDS_USER_MESSAGE"] = "暂停此用户的游玩。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_TITLE"] = "无法启用";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MAX_WARNING_MESSAGE"] =
  "最多只能有 4 位活动用户。\n若要启用此用户，请先停用（或删除）另一位不需要的用户。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_TITLE"] = "无法更改";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_MIN_WARNING_MESSAGE"] =
  "至少需要一位用户。\n无法再减少用户数量。";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_TITLE"] = "无法更改";
translations["MSG_SETTING_PARENTS_CHANGE_KIDS_USER_ACTIVE_WARNING_MESSAGE"] =
  "无法暂停当前登录的用户。\n请先切换到其他用户，然后再暂停此用户。";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_TITLE"] = "登出";
translations["MSG_SETTING_PARENTS_USER_SIGN_OUT_MESSAGE"] =
  "登出账户后，您将无法使用当前的用户游玩。\n用户信息已保存在账户中，如果您想再次使用相同的用户游玩，请使用此账户重新登录。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_TITLE"] = "【重要】请注意";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_WARNING_MESSAGE"] =
  "从'乐学拼图'删除您的账户将删除以下所有数据：\n・注册的个人资料和账户信息。\n・所有已注册的用户信息。\n・用户在「自由创作」中创建的应用程序。\n・用户在「通过课程学习」中完成的所有成绩和成就。\n・用户进行的「对话记录」等。\n* 【重要】删除已登录的账户将删除与此账户相关的所有数据，请务必小心。\n* 【重要】此操作在任何情况下都无法恢复。删除账户时请务必小心。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_FORM_TITLE"] = "请告诉我们删除账户的原因。";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_TITLE"] = "您确定要删除账户吗？";
translations["MSG_SETTING_PARENTS_USER_UNSUBSCRIBE_MESSAGE"] =
  "删除账户将移除所有数据，包括账户和用户。\n账户删除后无法恢复。请小心操作。";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_TITLE"] = "无法链接";
translations["MSG_SETTING_PARENTS_USER_PROFILE_ACCOUNT_LINK_ALREADY_ERROR_MESSAGE"] =
  "社交账户已链接到另一个账户。";
translations["MSG_SETTING_PARENTS_USER_KIDS_PROFILE_CREATED_AT"] = "注册日期";
translations["MSG_SETTING_PARENTS_USER_PROFILE_LATEST_AT"] = "上次登录日期";
translations["MSG_SETTING_PARENTS_USER_PROFILE_UNSUBSCRIBE_BTN"] = "删除账户";
translations["MSG_SETTING_PARENTS_USER_PROFILE_DISPLAY_NAME_LIMIT"] =
  "请输入 %{limit} 个字符以内。";

translations["MSG_SETTING_COURSE_ANSWER_COURSE_TITLE"] = "选择课程";
translations["MSG_SETTING_COURSE_ANSWER_STAGE_TITLE"] = "选择关卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL_TITLE"] = "选择等级";
translations["MSG_SETTING_COURSE_ANSWER_STAGE"] = "关卡";
translations["MSG_SETTING_COURSE_ANSWER_LEVEL"] = "等级";
translations["MSG_SETTING_PARENTS_LINK_ADD_USER_AUTH_CODE_TITLE"] = "验证码";

translations["MSG_CONTACT_TITLE"] = "联系我们";
translations["MSG_CONTACT_TYPE_TITLE"] = "选择询问类型";
translations["MSG_CONTACT_DETAIL_TITLE"] = "请告诉我们详细信息";
translations["MSG_CONTACT_DETAIL_LOCKED"] = "在上方选择类型后，就可以在这里填写";
translations["MSG_CONTACT_TYPE_HOW_TO"] = "不知道\n如何使用";
translations["MSG_CONTACT_TYPE_BUG"] = "无法\n正常运行";
translations["MSG_CONTACT_TYPE_REQUEST"] = "功能\n请求";
translations["MSG_CONTACT_TYPE_OTHER"] = "其他\n问题";
translations["MSG_CONTACT_SEND_BTN"] = "发送询问";
translations["MSG_SETTING_SHAKE_BUG_REPORT"] = "摇动告知";
translations["MSG_SHAKE_BUG_REPORT_TITLE"] = "有无法使用的地方吗？";
translations["MSG_SHAKE_BUG_REPORT_DESCRIPTION"] =
  "请通过询问告诉我们。\n也可以一起发送摇动时的画面。";
translations["MSG_SHAKE_BUG_REPORT_CONTACT_BTN"] = "联系我们";
translations["MSG_SHAKE_BUG_REPORT_CAPTURE_BTN"] = "附上画面联系我们";
translations["MSG_SHAKE_BUG_REPORT_TOGGLE_LABEL"] = "摇动告知";
translations["MSG_SHAKE_BUG_REPORT_TOGGLE_DESCRIPTION"] = "关闭后，摇动将不再显示此画面。";
translations["MSG_CONTACT_CAPTURE_LABEL"] = "发送的画面";
translations["MSG_CONTACT_CAPTURE_DESCRIPTION"] = "可以一起发送\n打开前的画面";
translations["MSG_CHAT_CAPTURE_SCREEN_BTN"] = "截取画面";
translations["MSG_CHAT_HINT_CAPTURE"] = "截取打开前的画面并附上";
translations["MSG_CHAT_HINT_UPLOAD"] = "附上照片或图片文件";
translations["MSG_CHAT_HINT_ASSET"] = "从「相册」「绘图本」「AI工作室」附上图片";
translations["MSG_CHAT_HINT_STAMP"] = "发送贴图";
translations["MSG_CHAT_ATTACHED_IMAGE_LABEL"] = "要发送的图片";
translations["MSG_CONTACT_CAPTURE_REMOVE_BTN"] = "移除";

translations["MSG_PARENT_GATE_WARNING"] = "请让成人\n确认此页面。";
translations["MSG_PARENT_GATE_TITLE"] = "家长专用";
translations["MSG_PARENT_GATE_DESCRIPTION"] =
  "以下屏幕是家长专用的设置和账户信息页面。\n若要显示屏幕，请按照指示顺序点击下方图片，然后按下继续按钮。";
translations["MSG_PARENT_GATE_CLOSE_BTN"] = translations["MSG_SETTING_CLOSE_BTN"];
translations["MSG_PARENT_GATE_CONFIRM_BTN"] = "继续";
translations["MSG_PARENT_GATE_QUESTION_TITLE"] = "请按此顺序点击图片：";
translations["MSG_PARENT_GATE_LONGPRESS_INSTRUCTION"] = "长按数字 「%{number}」。";
translations["MSG_PARENT_GATE_SHAPE_RECT"] = "方形";
translations["MSG_PARENT_GATE_SHAPE_STAR"] = "星形";
translations["MSG_PARENT_GATE_SHAPE_CIRCLE"] = "圆形";
translations["MSG_PARENT_GATE_SHAPE_TRIANGLE"] = "三角形";
// MSG_PARENTS_PROFILE_DEFAULT_NAME 已在上方定义

translations["MSG_PARENT_REGISTRATION_MESSAGE_COURSE"] =
  "「体验计划」只能游玩算法冒险的第1关和第2关。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_PROJECT_LIMIT"] =
  "「体验计划」最多可以创建%{limit}个应用。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_CHILD_USER_LIMIT"] =
  "「体验计划」最多可以添加%{limit}名玩家。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_CHAT_LIMIT"] =
  "「体验计划」每天最多可发送%{limit}次。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_AI_IMAGE_LIMIT"] =
  "「体验计划」每天最多可制作%{limit}次。";
translations["MSG_PARENT_REGISTRATION_MESSAGE_ASSET_LIMIT"] =
  "「体验计划」最多可保存 100 MB 的素材。";

translations["MSG_COURSE_COMING_SOON_WARNING_MESSAGE"] = "此卡带尚无法游玩。\n请再稍候！";
translations["MSG_COURSE_START_BTN"] = "开始";
translations["MSG_COURSE_GOTO_MAP_BTN"] = "前往地图";
translations["MSG_COURSE_STAGE_CLEAR_TITLE"] = "已完成至此！";
translations["MSG_COURSE_LEVEL_OVERVIEW_SUMMARY"] = "此等级将学习的内容";
translations["MSG_COURSE_LEVEL_OVERVIEW_START_BTN"] = "开始";
translations["MSG_COURSE_GAME_TIPS_NEXT_BTN"] = "下一步";
translations["MSG_COURSE_GAME_TIPS_BACK_BTN"] = "上一步";
translations["MSG_COURSE_GAME_TIPS_ACTION_BTN"] = "试试看";
translations["MSG_COURSE_GAME_HINT_BTN"] = "提示";
translations["MSG_COURSE_GAME_CLEAR"] = "完成";
translations["MSG_COURSE_GAME_SCORE_TEXT"] = "获得的物品";
translations["MSG_COURSE_GAME_SCORE_STATUS"] = "%{count} / %{total}"; // 使用计数
translations["MSG_COURSE_GAME_START_BTN"] = "开始！";
translations["MSG_COURSE_GAME_RESET_BTN"] = "重试";
translations["MSG_COURSE_GAME_SUCCESS_TEXT"] = "恭喜！您已完成此等级！";
translations["MSG_COURSE_GAME_SUCCESS_REVIEW_BTN"] = "回顾";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_LEVEL_BTN"] = "下一等级";
translations["MSG_COURSE_GAME_SUCCESS_NEXT_STAGE_BTN"] = "下一关卡";
translations["MSG_COURSE_GAME_FAILED_TITLE"] = "太可惜了！";
translations["MSG_COURSE_GAME_FAILED_TEXT"] = "再来一次吧！\n\n如果太难了，\n请参考提示。";
translations["MSG_COURSE_GAME_FAILED_RESET_BTN"] = "再试一次";
translations["MSG_COURSE_GAME_STAGE_CLEAR"] = "恭喜！关卡完成！";
translations["MSG_COURSE_ALL_GAME_STAGE_CLEAR"] =
  "恭喜！\n您已完成目前\n所有可用的关卡！\n敬请期待\n新关卡的加入！";
translations["MSG_COURSE_PROGRAM_RUN"] = "运行";
translations["MSG_COURSE_ALGORITHM"] = "学习算法！";
translations["MSG_COURSE_PROGRAM"] = "编程入门";
translations["MSG_COURSE_ALGORITHM_ADVANCED"] = "算法进阶";
translations["MSG_COURSE_SOKOBAN"] = "推箱子谜题";
translations["MSG_COURSE_SOKOBAN_DESCRIPTION"] = "推动箱子，送到目的地！";
translations["MSG_COURSE_SOKOBAN_LEVEL"] = "关卡";
translations["MSG_COURSE_PIECE_BUILDER"] = "拼图建造";
translations["MSG_BUILDER_TAB_MY_MAPS"] = "我的拼图";
translations["MSG_BUILDER_TAB_PUBLIC_MAPS"] = "大家的拼图";
translations["MSG_BUILDER_TAB_TRASH"] = "垃圾箱";
translations["MSG_BUILDER_LAYOUT_GRID_1"] = "1列";
translations["MSG_BUILDER_LAYOUT_GRID_2"] = "2列";
translations["MSG_BUILDER_LAYOUT_LIST"] = "列表";
translations["MSG_BUILDER_LAYOUT_SWITCH"] = "切换布局";
translations["MSG_BUILDER_SECTION_FILTER"] = "筛选";
translations["MSG_BUILDER_CLEAR_BTN"] = "清除";
translations["MSG_BUILDER_SECTION_SORT"] = "排序";
translations["MSG_BUILDER_SECTION_LAYOUT"] = "显示";
translations["MSG_BUILDER_PUBLIC_COMING_SOON"] = "即将开放！";
translations["MSG_BUILDER_NEW_PIECE_NAME"] = "新拼图";
translations["MSG_BUILDER_NEW_MAP_BTN"] = "新拼图";
translations["MSG_BUILDER_SCROLL_TO_BOTTOM_BTN"] = "滚动到底部";
translations["MSG_BUILDER_NEW_MAP_TITLE"] = "创建新拼图";
translations["MSG_BUILDER_MAP_DETAIL_BTN"] = "详情";
translations["MSG_BUILDER_MAP_EDIT_BTN"] = "编辑";
translations["MSG_BUILDER_MAP_RUN_BTN"] = "运行";
translations["MSG_BUILDER_MAP_COUNT"] = "%{count} 个拼图";
translations["MSG_BUILDER_FILTER_ALL"] = "全部";
translations["MSG_BUILDER_FILTER_FAVORITE"] = "收藏";
translations["MSG_BUILDER_FILTER_DRAFT"] = "草稿";
translations["MSG_BUILDER_FILTER_EDITING"] = "编辑中";
translations["MSG_BUILDER_FILTER_AXIS_COMPLETED"] = "完成状态";
translations["MSG_BUILDER_FILTER_AXIS_PUBLISHED"] = "公开状态";
translations["MSG_BUILDER_FILTER_AXIS_OTHER"] = "其他";
translations["MSG_BUILDER_SORT_DESC"] = "最新";
translations["MSG_BUILDER_SORT_ASC"] = "最旧";
translations["MSG_BUILDER_SORT_POPULAR"] = "人气";
translations["MSG_BUILDER_SORT_MANY"] = "数量多";
translations["MSG_BUILDER_SORT_FEW"] = "数量少";
translations["MSG_BUILDER_SORT_AXIS_UPDATED"] = "日期";
translations["MSG_BUILDER_SORT_AXIS_DELETED"] = "删除日";
translations["MSG_BUILDER_SORT_AXIS_LIKED"] = "赞";
translations["MSG_BUILDER_SORT_AXIS_PLAYED"] = "游玩";
translations["MSG_BUILDER_SORT_AXIS_VIEWED"] = "浏览";
translations["MSG_BUILDER_SORT_AXIS_REACTION"] = "反应";
translations["MSG_BUILDER_SORT_ORDER"] = "顺序";
translations["MSG_BUILDER_PUBLIC_COUNT"] = "%{count} 个拼图";
translations["MSG_BUILDER_PUBLIC_FILTER_OFFICIAL"] = "官方";
translations["MSG_BUILDER_PUBLIC_FILTER_TEMPLATE_AXIS"] = "类型";
translations["MSG_BUILDER_PUBLIC_FILTER_UNOFFICIAL"] = "非官方";
translations["MSG_BUILDER_PUBLIC_FILTER_COPYABLE"] = "可复制";
translations["MSG_BUILDER_PUBLIC_FILTER_REMIX"] = "二次创作";
translations["MSG_BUILDER_PUBLIC_FILTER_POPULAR"] = "人气";
translations["MSG_BUILDER_PUBLIC_FILTER_COMMENTABLE"] = "可评论";
translations["MSG_BUILDER_PUBLIC_FILTER_COPIED"] = "复制";
translations["MSG_BUILDER_TRASH_COUNT"] = "垃圾箱 %{count} 个";
translations["MSG_BUILDER_TRASH_SORT"] = "按删除时间";
translations["MSG_BUILDER_CARD_STATUS_DRAFT"] = "草稿";
translations["MSG_BUILDER_CARD_STATUS_EDITING"] = "编辑中";
translations["MSG_BUILDER_CARD_STATUS_UNPUBLISHED"] = "未公开";
translations["MSG_BUILDER_CARD_STATUS_PUBLISHED"] = "公开中";
translations["MSG_BUILDER_CARD_STATUS_COMPLETED"] = "已完成";
translations["MSG_BUILDER_CARD_STATUS_INCOMPLETE"] = "制作中";
translations["MSG_BUILDER_CARD_STATUS_REMOVED"] = "已删除";
translations["MSG_BUILDER_CARD_STATUS_BLOCKED"] = "已被屏蔽";
translations["MSG_BUILDER_CARD_STATUS_OFFICIAL"] = "官方";
translations["MSG_BUILDER_CARD_STATUS_ORIGINAL"] = "原创";
translations["MSG_BUILDER_CARD_STATUS_REMIX"] = "二次创作";
translations["MSG_BUILDER_CARD_BADGE_REMIX"] = "混编";
translations["MSG_BUILDER_CARD_REMIX_FROM"] = "原作: %{name}";
translations["MSG_BUILDER_BTN_PLAY"] = "玩";
translations["MSG_BUILDER_BTN_CONTINUE"] = "继续";
translations["MSG_BUILDER_BTN_PUBLISHED_NOW"] = "玩已公开版";
translations["MSG_BUILDER_BTN_RESUME"] = "继续编辑";
translations["MSG_BUILDER_BTN_RESTORE"] = "恢复";
translations["MSG_BUILDER_TOOL_UNDO"] = "撤销";
translations["MSG_BUILDER_TOOL_REDO"] = "重做";
translations["MSG_BUILDER_TOOL_TAP"] = "点击";
translations["MSG_BUILDER_TOOL_ERASER"] = "橡皮擦";
translations["MSG_BUILDER_TOOL_ZOOM"] = "缩放";
translations["MSG_BUILDER_TOOL_RESET"] = "重置";
translations["MSG_BUILDER_TOOL_ZOOM_OUT"] = "缩小";
translations["MSG_BUILDER_TOOL_ZOOM_IN"] = "放大";
translations["MSG_BUILDER_BTN_DELETE_FOREVER"] = "删除";
translations["MSG_BUILDER_BTN_PUBLISH"] = "公开";
translations["MSG_BUILDER_BTN_UNPUBLISH"] = "设为私密";
translations["MSG_BUILDER_TOGGLE_PUBLISH_TOAST"] = "已公开";
translations["MSG_BUILDER_TOGGLE_UNPUBLISH_TOAST"] = "已设为私密";
translations["MSG_BUILDER_BTN_COPY"] = "复制";
translations["MSG_BUILDER_MENU_HINT"] = "写提示";
translations["MSG_BUILDER_MENU_COPY"] = "复制并创建";
translations["MSG_BUILDER_MENU_TO_TRASH"] = "移到垃圾箱";
translations["MSG_BUILDER_MENU_LIKE"] = "点赞";
translations["MSG_BUILDER_MENU_REACTION"] = "反应";
translations["MSG_BUILDER_OPEN_PIECE_BTN"] = "查看拼图";
translations["MSG_BUILDER_MENU_REPORT"] = "举报";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_TITLE"] = "移到垃圾箱？";
translations["MSG_BUILDER_TO_TRASH_CONFIRM_MSG"] = "将「%{name}」移到垃圾箱。之后可以恢复。";
translations["MSG_BUILDER_TO_TRASH_TOAST"] = "已移到垃圾箱";
translations["MSG_BUILDER_TRASH_RESTORE_TOAST"] = "已恢复";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_TITLE"] = "永久删除？";
translations["MSG_BUILDER_TRASH_DELETE_CONFIRM_MSG"] = "永久删除「%{name}」。无法撤销。";
translations["MSG_BUILDER_TRASH_DELETE_TOAST"] = "已删除";
translations["MSG_BUILDER_LIKE_TOAST"] = "已点赞！";
translations["MSG_BUILDER_COPY_TOAST"] = "已复制！";
translations["MSG_BUILDER_RESTORE_CONFIRM_TITLE"] = "要还原吗？";
translations["MSG_BUILDER_REPORT_THANKS"] = "谢谢你告诉我们！";
translations["MSG_BUILDER_REPORT_PIECE_CONFIRM"] = "将告知运营团队。\n对方不会知道是谁报告的。";
translations["MSG_BUILDER_REPORT_REASON_TITLE"] = "为什么要报告？";
translations["MSG_BUILDER_REPORT_REASON_INAPPROPRIATE"] = "不好的词语";
translations["MSG_BUILDER_REPORT_REASON_DISLIKE"] = "不舒服";
translations["MSG_BUILDER_REPORT_REASON_SPAM"] = "重复很多";
translations["MSG_BUILDER_REPORT_REASON_COPYRIGHT"] = "别人的作品";
translations["MSG_BUILDER_REPORT_REASON_OTHER"] = "其他";
translations["MSG_BUILDER_REPORT_DETAIL_LABEL"] = "请详细告诉我们";
translations["MSG_BUILDER_COPY_NOT_ALLOWED"] = "这个拼图不能复制";
translations["MSG_BUILDER_REPORT_NEED_ACCOUNT"] = "只有注册用户才能举报。";
translations["MSG_BUILDER_DETAIL_TAB_RANKING"] = "排行榜";
translations["MSG_BUILDER_DETAIL_AUTHOR_BY"] = "%{name} 制作";
translations["MSG_BUILDER_DETAIL_APP_CODE"] = "应用代码";
translations["MSG_BUILDER_DETAIL_PUBLISHED_AT"] = "公开日";
translations["MSG_BUILDER_DETAIL_UPDATED_AT"] = "更新日";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES"] = "最少步数";
translations["MSG_BUILDER_DETAIL_RANKING_TIME"] = "最快时间";
translations["MSG_BUILDER_DETAIL_RANKING_WORLD"] = "世界纪录";
translations["MSG_BUILDER_DETAIL_RANKING_MOVES_UNIT"] = "%{n} 步";
translations["MSG_BUILDER_DETAIL_RANKING_EMPTY"] = "还没有人通关";
translations["MSG_BUILDER_DETAIL_HINT_EMPTY"] = "没有提示";
translations["MSG_BUILDER_DETAIL_RANKING_YOU"] = "你";
translations["MSG_BUILDER_DETAIL_HINT_TITLE"] = "写提示";
translations["MSG_BUILDER_DETAIL_HINT_DESC"] = "留空会自动生成";
translations["MSG_BUILDER_DETAIL_HINT_LV1"] = "① 简单";
translations["MSG_BUILDER_DETAIL_HINT_LV2"] = "② 普通";
translations["MSG_BUILDER_DETAIL_HINT_LV3"] = "③ 答案";
translations["MSG_BUILDER_DETAIL_HINT_PLACEHOLDER"] = "写下提示";
translations["MSG_BUILDER_DETAIL_HINT_SECTION"] = "提示";
translations["MSG_BUILDER_DETAIL_CHANGE_COVER"] = "更换封面";
translations["MSG_BUILDER_DETAIL_CHANGE_BACKGROUND"] = "更换背景";
translations["MSG_BUILDER_DETAIL_EDIT_BTN"] = "修改";
translations["MSG_BUILDER_CARD_DETAIL_BTN"] = "更多";
translations["MSG_BUILDER_DETAIL_TAB_COMMAND"] = "指令";
translations["MSG_BUILDER_DETAIL_TAB_COMMENT"] = "评论";
translations["MSG_BUILDER_DETAIL_REACTION_HINT"] = "点一下告诉对方感受";
translations["MSG_BUILDER_DETAIL_EXPAND"] = "展开";
translations["MSG_BUILDER_DETAIL_COLLAPSE"] = "收起";
translations["MSG_BUILDER_DETAIL_COMMAND_DESC"] = "这块拼图可以使用的指令";
translations["MSG_BUILDER_DETAIL_COMMENT_INPUT_PLACEHOLDER"] = "写下你的评论";
translations["MSG_BUILDER_DETAIL_COMMENT_POST"] = "发布";
translations["MSG_BUILDER_DETAIL_COMMENT_SHOW_REPLIES"] = "查看回复 (%{n})";
translations["MSG_BUILDER_DETAIL_COMMENT_HIDE_REPLIES"] = "收起回复";
translations["MSG_BUILDER_DETAIL_COMMENT_DELETE"] = "删除";
translations["MSG_BUILDER_DETAIL_COMMENT_REPORT"] = "举报";
translations["MSG_BUILDER_DETAIL_COMMENT_REPLY"] = "回复";
translations["MSG_BUILDER_DETAIL_COMMENT_REPORT_CONFIRM"] =
  "将告知运营团队。\n对方不会知道是谁报告的。";
translations["MSG_BUILDER_DETAIL_COMMENT_DELETE_CONFIRM"] = "要删除这条评论吗？";
translations["MSG_BUILDER_DETAIL_COMMENT_GUEST_HINT"] = "注册后即可评论";
translations["MSG_BUILDER_DETAIL_COMMENT_EMPTY"] = "还没有评论";
translations["MSG_BUILDER_DETAIL_TIME_MIN_AGO"] = "%{n} 分钟前";
translations["MSG_BUILDER_DETAIL_TIME_HOUR_AGO"] = "%{n} 小时前";
translations["MSG_BUILDER_DETAIL_TIME_DAY_AGO"] = "%{n} 天前";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_TITLE"] = "游戏玩法";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_DESC"] = "把所有箱子推到目标上！";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_TITLE"] = "操作方法";
translations["MSG_SOKOBAN_TUTORIAL_CONTROLLER_DESC"] = "用右下方的按钮来移动角色";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_TITLE"] = "摄像机操作";
translations["MSG_SOKOBAN_TUTORIAL_CAMERA_DESC"] = "拖动左下方的圆圈可以旋转摄像机";
translations["MSG_SOKOBAN_TUTORIAL_BTN_FORWARD"] = "前进";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_LEFT"] = "左转";
translations["MSG_SOKOBAN_TUTORIAL_BTN_TURN_RIGHT"] = "右转";
translations["MSG_SOKOBAN_TUTORIAL_BTN_JUMP"] = "跳跃";
translations["MSG_SOKOBAN_TUTORIAL_NEXT_BTN"] = "下一步";
translations["MSG_SOKOBAN_TUTORIAL_START_BTN"] = "开始！";
translations["MSG_SOKOBAN_TUTORIAL_TITLE"] = "新手教程";
translations["MSG_SOKOBAN_TUTORIAL_TAP_TO_CONTINUE"] = "点击继续";
translations["MSG_SOKOBAN_TUTORIAL_GOAL_HINT"] = "目标在这里！";
translations["MSG_COURSE_GROUP_WORK"] = "小组合作";
translations["MSG_COURSE_COORDINATE_X"] = "水平位置（X 坐标）";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_NEXT_BTN"] = "下一步";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_LATER_BTN"] = "稍后查看";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CONTINUE_BTN"] = "继续指南";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_ACTION_BTN"] = "试试看";
translations["MSG_CREATOR_TOP_TUTORIAL_TIPS_CLOSE_BTN"] = "结束指南";
translations["MSG_CREATOR_CREATE_APP"] = "创建应用";
translations["MSG_CREATOR_CREATE_APP_TITLE"] = "创建应用程序";
translations["MSG_CREATOR_CREATE_APP_NAME"] = "请为应用程序命名。";
translations["MSG_CREATOR_CREATE_APP_NAME_PREFIX"] = "应用程序";
translations["MSG_CREATOR_APP_DETAIL_BTN"] = "详细信息";
translations["MSG_CREATOR_RUN_APP_BTN"] = "运行";
translations["MSG_CREATOR_APP_MY_APPS"] = "我的应用程序";
translations["MSG_CREATOR_APP_SHARED_APPS"] = "共享应用程序";
translations["MSG_CREATOR_APP_SHARED_APPS_EMPTY_MESSAGE"] =
  "找不到符合这些条件的应用程序。\n请更改条件再试一次。";
translations["MSG_CREATOR_APP_DELETED_APPS"] = "垃圾桶";
translations["MSG_CREATOR_APP_DELETED_APPS_MESSAGE"] =
  "选择您想移回\n「我的应用程序」的应用程序。\n（最多保留5个\n最近删除的应用程序）";
translations["MSG_CREATOR_APP_SETTING_TITLE"] = "应用程序设置";
translations["MSG_CREATOR_APP_SETTING_APP_NAME"] = "应用程序名称";
translations["MSG_CREATOR_APP_SETTING_APP_TAG"] = "标签";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_TITLE"] = "发布至「共享应用程序」？";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_OFF"] = "私有";
translations["MSG_CREATOR_APP_SETTING_PUBLISH_STATUS_ON"] = "公开";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_TITLE"] = "允许他人复制";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_OFF"] = "禁止\n复制";
translations["MSG_CREATOR_APP_SETTING_ENABLE_COPIED_STATUS_ON"] = "允许\n复制";
translations["MSG_CREATOR_APP_SETTING_APP_CHANGE_COVER_PAGE_BTN"] = "更改封面页";
translations["MSG_CREATOR_APP_DETAIL_APP_AUTHOR"] = "原创作者";
translations["MSG_CREATOR_APP_DETAIL_APP_EDITOR"] = "上次编辑者";
translations["MSG_CREATOR_APP_NAME_PLACEHOLDER"] = "输入名称";
translations["MSG_CREATOR_APP_SELECT_PLACEHOLDER"] = "select app";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_TITLE"] = "应用程序说明";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_NONE"] = "没有说明";
translations["MSG_CREATOR_APP_DETAIL_DESCRIPTION_PLACEHOLDER"] = "输入应用程序说明";
translations["MSG_CREATOR_APP_DETAIL_TITLE_APP_CODE"] = "应用程序\n代码";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP"] = "共享\n应用程序";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_PUBLISHED"] = "公开";
translations["MSG_CREATOR_APP_DETAIL_TITLE_SHARED_APP_NOT_PUBLISHED"] = "私有";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS"] = "自我介绍人";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_ENABLE"] = "可复制";
translations["MSG_CREATOR_APP_DETAIL_INPUT_COPIED_STATUS_DISABLE"] = "不可复制";
translations["MSG_CREATOR_APP_DETAIL_APP_DELETED_AT"] = "删除\n日期";
translations["MSG_CREATOR_APP_EDITOR_BTN"] = "创建";
translations["MSG_CREATOR_APP_COMPLETELY_BTN"] = "永久删除";
translations["MSG_CREATOR_APP_RESTORE_BTN"] = "还原";
translations["MSG_CREATOR_APP_DELETE_WARNING_TITLE"] = "删除应用程序？";
translations["MSG_CREATOR_APP_DELETE_WARNING_MESSAGE"] =
  '删除 "%{name}"？\n您将无法编辑此应用程序。\n您将无法使用此应用程序。';
translations["MSG_CREATOR_ASSET_DELETE_WARNING_TITLE"] = "删除图片？";
translations["MSG_CREATOR_ASSET_DELETE_WARNING_MESSAGE"] =
  '删除 "%{name}"？\n删除后，图片将无法恢复。';
translations["MSG_CREATOR_CREATE_APP_PICKUP_NAME"] = "精选";
translations["MSG_CREATOR_CREATE_APP_PICKUP_MONTH_TITLE"] = "%{month} 月的"; // 例如："八月的"；
translations["MSG_CREATOR_CREATE_APP_PICKUP_SUBTITLE"] = "介绍有趣的应用程序！";
translations["MSG_CREATOR_APP_PUBLISH_TITLE"] = "发布至「共享应用程序」？";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_TITLE"] = "无法发布应用程序";
translations["MSG_CREATOR_APP_BLOCKED"] = "已被屏蔽\n无法公开";
translations["MSG_CREATOR_APP_CARD_BLOCKED"] = "已屏蔽";
translations["MSG_CREATOR_APP_PUBLISH_DISABLED_MESSAGE"] =
  "不允许发布应用程序。\n请从家长菜单中允许。";
// 運営がかけた機能の制限（管理画面から。保護者の許可とは別）
translations["MSG_USER_RESTRICTION_PROJECT_PUBLISH_MESSAGE"] =
  "运营%{until}停止了应用的发布。\n详情请查看「联系我们」。";
translations["MSG_USER_RESTRICTION_PIECE_PUBLISH_TITLE"] = "无法发布拼图";
translations["MSG_USER_RESTRICTION_PIECE_PUBLISH_MESSAGE"] =
  "运营%{until}停止了拼图的发布。\n详情请查看「联系我们」。";
translations["MSG_USER_RESTRICTION_UNTIL"] = "到%{date}为止";
translations["MSG_USER_RESTRICTION_UNTIL_NONE"] = "暂时";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_TITLE"] = "停止发布至「共享应用程序」？";
translations["MSG_CREATOR_APP_PUBLISH_WARNING"] =
  "将「%{name}」发布至「共享应用程序」。\n发布应用程序后，自我介绍人将可以使用它。";
translations["MSG_CREATOR_APP_DISABLE_PUBLISH_WARNING"] =
  "停止将「%{name}」发布至「共享应用程序」。\n停止发布后，自我介绍人将无法使用此应用程序。";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_ENABLE"] = "发布并允许复制";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_DISABLE"] = "发布并禁止复制";
translations["MSG_CREATOR_APP_PUBLISH_COPIED_NOTICE"] = "* 您稍后可以取消发布应用程序。";
translations["MSG_CREATOR_PUBLISH_CONFIRM_BTN"] = "发布";
translations["MSG_CREATOR_DISABLE_PUBLISH_CONFIRM_BTN"] = "设为私有";
translations["MSG_CREATOR_APP_ENABLE_COPIED_TITLE"] = "此应用程序的复制设置";
translations["MSG_CREATOR_APP_DISABLE_COPIED_TITLE"] = "此应用程序的复制设置";
translations["MSG_CREATOR_APP_ENABLE_COPIED_MESSAGE"] = '允许自我介绍人复制 "%{name}"。';
translations["MSG_CREATOR_APP_DISABLE_COPIED_MESSAGE"] = '禁止自我介绍人复制 "%{name}"。';
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_TITLE"] = "此图片无法使用";
translations["MSG_CREATOR_ASSET_LIMIT_WARNING_MESSAGE"] =
  "只能将最新的 %{limit} 张图片添加到应用程序。\n当自我介绍图片可以使用时，我们会通知您。";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_TITLE"] = "无法删除应用程序";
translations["MSG_CREATOR_APP_DELETE_PUBLISHED_WARNING_MESSAGE"] =
  "无法删除已发布至共享应用程序的应用程序。\n如果您想删除此应用程序，请先将其设为私有。\n";
translations["MSG_CREATOR_APP_SORT_FILTER_TITLE"] = "查找";
translations["MSG_CREATOR_APP_KEYWORD_SEARCH_TITLE"] = "通过关键字查找";
translations["MSG_CREATOR_APP_SORT_TITLE"] = "排序";
translations["MSG_CREATOR_APP_SORT_FAVORITED"] = "热门度";
translations["MSG_CREATOR_APP_SORT_VIEWED"] = "热门度";
translations["MSG_CREATOR_APP_SORT_DATE"] = "时间";
translations["MSG_CREATOR_APP_FILTER_TITLE"] = "筛选";
translations["MSG_CREATOR_APP_FILTER_OFFICIAL"] = "官方";
translations["MSG_CREATOR_APP_FILTER_FAVORITED"] = "已点赞";
translations["MSG_CREATOR_APP_DISABLE_BTN"] = "无法";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_TITLE"] = "永久删除应用程序？";
translations["MSG_CREATOR_APP_COMPLETE_DELETE_CONFIRM_SUBTITLE"] =
  '永久删除 "%{name}"？\n永久删除后，应用程序将无法恢复。';
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_TITLE"] = "还原至「我的应用程序」？";
translations["MSG_CREATOR_APP_RESTORE_CONFIRM_SUBTITLE"] = '还原 "%{name}" 至"我的应用程序"？';
translations["MSG_CREATOR_SCREEN_LIST_HEADER"] = "页面";
translations["MSG_CREATOR_COMPONENT_LIST_HEADER"] = "已选定";
translations["MSG_CREATOR_MENU_CONTEXT_DELETE"] = "删除";
translations["MSG_CREATOR_MENU_CONTEXT_COPY"] = "复制";
translations["MSG_CREATOR_MENU_CASSETTE_ACTION"] = "卡带操作";
translations["MSG_CREATOR_MENU_RUN_APP_BTN"] = "运行\n应用程序";
translations["MSG_CREATOR_MENU_SET_APP_BTN"] = "应用程序\n设置";
// じゆうにつくる: できた！・こうかいを こうしん・へんこうの きろく（ドラフトとバージョン）
translations["MSG_CREATOR_MENU_PUBLISH_UPDATE_BTN"] = "更新\n公开";
translations["MSG_CREATOR_MENU_HISTORY_BTN"] = "查看\n记录";
translations["MSG_CREATOR_HISTORY_TITLE"] = "查看记录";
translations["MSG_CREATOR_HISTORY_EMPTY"] = "还没有记录";
translations["MSG_CREATOR_HISTORY_REASON_COMPLETE"] = "完成！";
translations["MSG_CREATOR_HISTORY_REASON_PUBLISH_UPDATE"] = "更新了公开";
translations["MSG_CREATOR_HISTORY_REASON_PUBLISH"] = "公开了";
translations["MSG_CREATOR_HISTORY_REASON_CLOSE"] = "关闭了应用程序";
translations["MSG_CREATOR_HISTORY_REASON_OPEN"] = "打开了应用程序";
translations["MSG_CREATOR_HISTORY_REASON_BEFORE_RESTORE"] = "恢复之前";
translations["MSG_CREATOR_HISTORY_REASON_MIGRATE"] = "最初的公开版本";
translations["MSG_CREATOR_HISTORY_REASON_AUTO"] = "中途的记录";
translations["MSG_CREATOR_HISTORY_REASON_RESTORE"] = "已还原";
translations["MSG_CREATOR_HISTORY_SAVE_BTN"] = "命名并保存";
translations["MSG_CREATOR_HISTORY_SAVE_DEFAULT_NAME"] = "存档点_%{time}";
translations["MSG_CREATOR_HISTORY_SAVE_NAME_DESCRIPTION"] = "请给这条记录取个名字。";
translations["MSG_CREATOR_HISTORY_REASON_SAVE"] = "已保存";
translations["MSG_CREATOR_TOAST_SAVED"] = "已保存";
translations["MSG_CREATOR_HISTORY_NOW"] = "现在";
translations["MSG_CREATOR_HISTORY_EDIT_UNDO_OF"] = "撤销了：%{action}";
translations["MSG_CREATOR_HISTORY_EDIT_REDO_OF"] = "重做了：%{action}";
translations["MSG_CREATOR_HISTORY_EDIT_RESTORE"] = "从记录还原了";
translations["MSG_CREATOR_HISTORY_RESTORE"] = "恢复";
translations["MSG_CREATOR_HISTORY_RESTORE_CONFIRM_TITLE"] = "要恢复到这个时候吗？";
translations["MSG_CREATOR_HISTORY_RESTORE_CONFIRM_MESSAGE"] =
  "恢复到「%{time}」的时候。\n现在的内容也会留在记录里，之后还能恢复。";
translations["MSG_CREATOR_HISTORY_RESTORE_CONFIRM_MESSAGE_PUBLISHED"] =
  "恢复到「%{time}」的时候。\n现在的内容也会留在记录里，之后还能恢复。\n公开中的应用程序在按下「更新公开」之前不会改变。";
translations["MSG_CREATOR_HISTORY_LIMIT_NOTE"] = "可以查看最新的%{limit}个（共%{total}个）";
translations["MSG_CREATOR_HISTORY_EDIT_ADD"] = "添加了%{target}";
translations["MSG_CREATOR_HISTORY_EDIT_REMOVE"] = "删除了%{target}";
translations["MSG_CREATOR_HISTORY_EDIT_CHANGE"] = "修改了%{target}";
translations["MSG_CREATOR_HISTORY_EDIT_CHANGE_BLOCKLY"] = "修改了%{target}的积木";
translations["MSG_CREATOR_HISTORY_EDIT_PASTE"] = "粘贴了";
translations["MSG_CREATOR_HISTORY_EDIT_UNDO"] = "撤销了一步";
translations["MSG_CREATOR_HISTORY_EDIT_REDO"] = "重做了";
translations["MSG_CREATOR_HISTORY_TARGET_COMPONENTS"] = "部件";
translations["MSG_CREATOR_PUBLISH_UPDATE_CONFIRM_TITLE"] = "要更新公开中的应用程序吗？";
translations["MSG_CREATOR_PUBLISH_UPDATE_CONFIRM_MESSAGE"] = "大家看到的应用程序会变成现在的内容。";
translations["MSG_CREATOR_TOAST_PUBLISH_UPDATED"] = "已更新公开中的应用程序";
translations["MSG_CREATOR_TOAST_RESTORED"] = "已恢复到「%{time}」的时候";
translations["MSG_CREATOR_TOAST_SAVE_FAILED"] = "无法保存。请检查网络连接。";
translations["MSG_CREATOR_MENU_PUBLISH_APP_BTN"] = "发布\n应用程序";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_APP_BTN"] = "取消发布\n应用程序";
translations["MSG_CREATOR_MENU_PUBLISH_TEMPLATE_BTN"] = "发布\n模板";
translations["MSG_CREATOR_MENU_STOP_PUBLISH_TEMPLATE_BTN"] = "取消发布\n模板";
translations["MSG_CREATOR_MENU_CLOSE_BTN"] = "关闭\n此屏幕";
translations["MSG_CREATOR_MENU_COMPONENT_BTN"] = "组件";
translations["MSG_CREATOR_MENU_COMPONENT_ACTION_BTN"] = "动作";
translations["MSG_CREATOR_MENU_COMPONENT_SHAPE_BTN"] = "形状";
translations["MSG_CREATOR_MENU_COMPONENT_STAMP_BTN"] = "图章";
translations["MSG_CREATOR_MENU_COMPONENT_STOCK_BTN"] = "工具箱";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_ACTION"] = "动作组件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_SHAPE"] = "形状组件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP"] = "图章组件";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_CHARACTER"] = "角色";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GAME"] = "活动/游戏";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ANIMAL"] = "动物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_EVENT"] = "活动";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_INTERNET"] = "互联网";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_MONEY"] = "经济/金钱";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_GOODS"] = "日用品";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_NATURE"] = "自然/植物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_PERSON"] = "人物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_BUILDING"] = "建筑物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_FOOD"] = "食物";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_ELECTRONIC"] = "电子/通信";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_SMILE"] = "笑脸";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_VEHICLE"] = "交通工具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_STATIONARY"] = "文具";
translations["MSG_CREATOR_MENU_COMPONENT_PIECE_STAMP_OTHERS"] = "自我介绍";
translations["MSG_CREATOR_MENU_DRAWING_BTN"] = "绘图";
translations["MSG_CREATOR_MENU_DRAWING_PEN"] = "画笔";
translations["MSG_CREATOR_MENU_DRAWING_ERASER"] = "橡皮擦";
translations["MSG_CREATOR_MENU_DRAWING_SIZE"] = "粗细";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_LIGHT"] = "细";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_NORMAL"] = "中";
translations["MSG_CREATOR_MENU_DRAWING_SIZE_BOLD"] = "粗";
translations["MSG_CREATOR_MENU_DRAWING_COLOR"] = "颜色";
translations["MSG_CREATOR_MENU_DRAWING_RESET"] = "重置";
translations["MSG_CREATOR_MENU_DRAWING_FINISH"] = "完成";
translations["MSG_CREATOR_MENU_STOCK_PARTS_USE_BTN"] = "添加";
translations["MSG_CREATOR_MENU_COMPONENT_PREVIEW_TITLE"] = "%{name} 组件列表";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_ALBUM_TITLE"] = "相册";
translations["MSG_CREATOR_MENU_ASSET_CATEGORY_DRAWING_TITLE"] = "绘图本";
translations["MSG_CREATOR_MENU_PROPERTY_BTN"] = "设计";
translations["MSG_CREATOR_MENU_PROPERTY_BASIC"] = "基本";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION"] = "位置";
translations["MSG_CREATOR_MENU_PROPERTY_SIZE"] = "大小";
translations["MSG_CREATOR_MENU_PROPERTY_APPEARANCE"] = "外观";
translations["MSG_CREATOR_MENU_PROPERTY_COLOR"] = "颜色";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC"] = "程序";
translations["MSG_CREATOR_MENU_PROPERTY_LOGIC_TITLE"] = "%{name} 的程序";

translations["MSG_CREATOR_MENU_PROPERTY_NAME"] = "名称";
translations["MSG_CREATOR_MENU_PROPERTY_NAME_PLACEHOLDER"] = "输入名称";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE_TITLE"] = "首页";
translations["MSG_CREATOR_MENU_PROPERTY_SET_TOP_PAGE"] = "从此页面开始";
translations["MSG_CREATOR_MENU_PROPERTY_FONT_FAMILY"] = "字体类型";
translations["MSG_CREATOR_TEXT_WEIGHT_BOLD"] = "粗体";
translations["MSG_CREATOR_TEXT_WEIGHT_REGULAR"] = "常规";
translations["MSG_CREATOR_TEXT_WEIGHT_LIGHT"] = "细体";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT"] = "显示内容";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX"] = "图层";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_FRONT"] = "移到最上层";
translations["MSG_CREATOR_MENU_PROPERTY_ZINDEX_BACK"] = "移到最下层";
translations["MSG_CREATOR_MENU_PROPERTY_POSITION_X_Y"] = "水平和垂直位置";
translations["MSG_CREATOR_MENU_PROPERTY_X"] = "水平位置";
translations["MSG_CREATOR_MENU_PROPERTY_Y"] = "垂直位置";
translations["MSG_CREATOR_MENU_PROPERTY_X_COORDINATE"] = "X";
translations["MSG_CREATOR_MENU_PROPERTY_Y_COORDINATE"] = "Y";
translations["MSG_CREATOR_MENU_PROPERTY_WIDTH"] = "宽度";
translations["MSG_CREATOR_MENU_PROPERTY_HEIGHT"] = "高度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER"] = "边框";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW"] = "阴影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SIZE"] = "文本";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW"] = "文本阴影";
translations["MSG_CREATOR_MENU_PROPERTY_OPACITY"] = "不透明度";
translations["MSG_CREATOR_MENU_PROPERTY_ROTATION"] = "角度";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_RADIUS"] = "圆角半径";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO"] = "图片信息";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_NAME"] = "名称";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_SIZE"] = "大小";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_FILE_SIZE"] = "文件大小";
translations["MSG_CREATOR_MENU_PROPERTY_IMAGE_INFO_BTN"] = "选择图片";
translations["MSG_CREATOR_MENU_PROPERTY_BACKGROUND_COLOR"] = "填充";
translations["MSG_CREATOR_MENU_PROPERTY_BORDER_COLOR"] = "边框";
translations["MSG_CREATOR_MENU_PROPERTY_SHADOW_COLOR"] = "阴影";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_COLOR"] = "文本";
translations["MSG_CREATOR_MENU_PROPERTY_TEXT_SHADOW_COLOR"] = "文本阴影";

translations["MSG_CREATOR_MENU_BLOCKLY_TITLE"] = "积木";
translations["MSG_CREATOR_MENU_BLOCKLY_EVENT"] = "事件";
translations["MSG_CREATOR_MENU_BLOCKLY_ANIMATION"] = "动作";
translations["MSG_CREATOR_MENU_BLOCKLY_CONTROL"] = "控制";
translations["MSG_CREATOR_MENU_BLOCKLY_LOGIC"] = "逻辑";
translations["MSG_CREATOR_MENU_BLOCKLY_MATH"] = "数学";
translations["MSG_CREATOR_MENU_BLOCKLY_VARIABLE"] = "变量";
translations["MSG_CREATOR_MENU_BLOCKLY_PROCEDURE"] = "函数";
translations["MSG_CREATOR_MENU_BLOCKLY_PROMPT_INPUT_MESSAGE"] = "%{placeholder} 的值";

translations["MSG_CREATOR_COMPONENT_NAME_SCREEN"] = "页面";
translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"] = "按钮";
translations["MSG_CREATOR_COMPONENT_NAME_LABEL"] = "标签";
translations["MSG_CREATOR_COMPONENT_NAME_FORM"] = "表单";
translations["MSG_CREATOR_COMPONENT_NAME_CHECKBOX"] = "复选框";
translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"] = "开关";
translations["MSG_CREATOR_COMPONENT_NAME_IMAGE"] = "图片";
translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"] = "圆形";
translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"] = "三角形";
translations["MSG_CREATOR_COMPONENT_NAME_RECT"] = "矩形";
translations["MSG_CREATOR_COMPONENT_NAME_STAR"] = "星形";
translations["MSG_CREATOR_COMPONENT_NAME_LINE"] = "线条";
translations["MSG_CREATOR_COMPONENT_NAME_STAMP"] = "图章";
translations["MSG_CREATOR_COMPONENT_NAME_DRAWING"] = "绘图";
translations["MSG_CREATOR_COMPONENT_LABEL_BUTTON"] =
  translations["MSG_CREATOR_COMPONENT_NAME_BUTTON"];
translations["MSG_CREATOR_COMPONENT_LABEL_LABEL"] =
  translations["MSG_CREATOR_COMPONENT_NAME_LABEL"];
translations["MSG_CREATOR_COMPONENT_LABEL_FORM"] = translations["MSG_CREATOR_COMPONENT_NAME_FORM"];
translations["MSG_CREATOR_COMPONENT_LABEL_CHECKBOX"] = "复选\n框";
translations["MSG_CREATOR_COMPONENT_LABEL_SWITCH"] =
  translations["MSG_CREATOR_COMPONENT_NAME_SWITCH"];
translations["MSG_CREATOR_COMPONENT_LABEL_IMAGE"] = "图片\n框";
translations["MSG_CREATOR_COMPONENT_LABEL_CIRCLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_CIRCLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_TRIANGLE"] =
  translations["MSG_CREATOR_COMPONENT_NAME_TRIANGLE"];
translations["MSG_CREATOR_COMPONENT_LABEL_RECT"] = "方形";
translations["MSG_CREATOR_COMPONENT_LABEL_STAR"] = translations["MSG_CREATOR_COMPONENT_NAME_STAR"];
translations["MSG_CREATOR_COMPONENT_LABEL_LINE"] = translations["MSG_CREATOR_COMPONENT_NAME_LINE"];

translations["MSG_BLOCKLY_VARIABLES"] = "变量";
translations["MSG_BLOCKLY_INPUT_NUMBER_LIMIT"] = "请输入数字。";
translations["MSG_BLOCKLY_INPUT_LENGTH_LIMIT"] = "请输入 %{limit} 个字符以内。";
translations["MSG_ASSET_ALBUM_TITLE"] = "相册内容";
translations["MSG_ASSET_DRAWING_TITLE"] = "绘图本内容";
translations["MSG_ASSET_ALBUM_ADD_TITLE"] = "添加图片";
translations["MSG_ASSET_DRAWING_ADD_ALBUM_TITLE"] =
  "在 '乐学拼图' 中添加的图片和照片将会添加到这里。";
translations["MSG_ASSET_DRAWING_ADD_WARNING_TITLE"] =
  "在「自由创作」的「绘图」菜单中绘制的图画将会添加到这里。";
translations["MSG_ASSET_ADD_TO_SCREEN_BTN"] = "添加到\n应用程序";
translations["MSG_CREATOR_MENU_MATERIAL_TAB_ASSET_SELECT"] = "添加到\n聊天";
translations["MSG_ASSET_DELETE_BTN"] = "删除\n图片";
translations["MSG_ASSET_ALBUM_EMPTY_MESSAGE"] = "尚无图片数据。";
translations["MSG_ASSET_DRAWING_EMPTY_MESSAGE"] = "尚无绘图数据。";
translations["MSG_ASSET_STORAGE_OVER_LIMIT"] = "存储空间已满";
translations["MSG_REACTION_TAG_TITLE"] = "心情图章";
translations["MSG_REACTION_USERS"] = "大家的\n心情";
translations["MSG_REACTION_DIFFICULT"] = "好难！";
translations["MSG_REACTION_EASY"] = "简单";
translations["MSG_REACTION_COOL"] = "赞！";
translations["MSG_REACTION_FUN"] = "好玩";
translations["MSG_REACTION_AMAZING"] = "厉害";
translations["MSG_REACTION_BAD"] = "嗯～？";

// User Plan
translations["MSG_CURRENT_PLAN"] = "当前计划";
translations["MSG_PLAN_TRIAL"] = "试用";
translations["MSG_PLAN_SAKIDORI"] = "抢先体验";
translations["MSG_PLAN_FREE"] = "Free";
translations["MSG_PLAN_EDUCATION"] = "Education";
translations["MSG_PLAN_STANDARD"] = "Standard";
translations["MSG_PLAN_PREMIUM"] = "高级";
translations["MSG_PLAN_BUILDER"] = "Builder";
translations["MSG_PLAN_UNKNOWN"] = "未知";
translations["MSG_PLAN_FREE_FULL"] = "Free套餐";
translations["MSG_PLAN_STANDARD_FULL"] = "Standard套餐";
translations["MSG_PLAN_PREMIUM_FULL"] = "高级套餐";
// Plan names for parent pages
translations["MSG_PLAN_TRIAL_PARENT"] = "试用";
translations["MSG_PLAN_FREE_PARENT"] = "免费";
translations["MSG_PLAN_STANDARD_PARENT"] = "基本";
translations["MSG_PLAN_PREMIUM_PARENT"] = "高级";
translations["MSG_PLAN_BUILDER_PARENT"] = "创作者";
translations["MSG_PLAN_EDUCATION_PARENT"] = "教室";
translations["MSG_PLAN_UNKNOWN_PARENT"] = "未知";
translations["MSG_PLAN_FREE_FULL_PARENT"] = "免费套餐";
translations["MSG_PLAN_STANDARD_FULL_PARENT"] = "基本套餐";
translations["MSG_PLAN_PREMIUM_FULL_PARENT"] = "高级套餐";

// Subscription - Common
translations["MSG_BACK_BTN"] = "返回";
// Subscription - Purchase Page
translations["MSG_SUBSCRIPTION_MONTHLY_TITLE"] = "月订阅";
translations["MSG_SUBSCRIPTION_ANNUAL_TITLE"] = "年订阅";
translations["MSG_SUBSCRIPTION_ANNUAL_BADGE"] = "节省2个月费用！";
translations["MSG_SUBSCRIPTION_PURCHASE_BTN"] = "购买";
translations["MSG_SUBSCRIPTION_UPGRADE_BTN"] = "升级";
translations["MSG_SUBSCRIPTION_PURCHASE_SUCCESS"] = "购买成功！";
translations["MSG_SUBSCRIPTION_PURCHASE_ERROR"] = "购买失败，请重试。";
// Subscription - Status Page
translations["MSG_SUBSCRIPTION_REACTIVATE_SUCCESS"] = "订阅已恢复";
translations["MSG_SUBSCRIPTION_REACTIVATE_ERROR"] = "恢复订阅失败";
translations["MSG_SUBSCRIPTION_PORTAL_ERROR"] = "无法打开入口";

// Subscription - Cancel Page
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_TITLE"] = "确定要取消吗？";
translations["MSG_SUBSCRIPTION_CANCEL_CONFIRM_MESSAGE"] =
  "您的订阅将在下次计费日期取消，您将返回免费计划。\n您的数据将被保留。";
translations["MSG_SUBSCRIPTION_CANCEL_SUCCESS"] = "已受理取消订阅";
translations["MSG_SUBSCRIPTION_CANCEL_ERROR"] = "取消订阅失败";
// 退款（冷静期）
// Stripe Elements支付模态框
// 家长页面 - 标签页
translations["MSG_PARENT_PAGE_TAB_ACCOUNT"] = "家长账号";
translations["MSG_PARENT_PAGE_TAB_PLAYER"] = "玩家管理";
translations["MSG_PARENT_PAGE_TAB_SUBSCRIPTION"] = "订阅管理";
translations["MSG_PARENT_PAGE_TAB_NOTIFICATION"] = "通知";
translations["MSG_PARENT_PAGE_TAB_MESSAGE"] = "消息";
translations["MSG_PARENT_PAGE_TAB_OTHER"] = "其他";

// 家长页面 - 消息标签页
translations["MSG_PARENT_PAGE_MESSAGE_INPUT_PLACEHOLDER"] = "输入消息...";
translations["MSG_PARENT_PAGE_MESSAGE_NO_ROOMS"] = "没有聊天室";
translations["MSG_PARENT_PAGE_MESSAGE_NO_MESSAGES"] = "暂无消息";
translations["MSG_PARENT_PAGE_MESSAGE_LOAD_MORE"] = "加载更多";
translations["MSG_LOADING"] = "加载中...";

// 家长页面 - 方案名称
translations["MSG_PARENT_PAGE_SUBSCRIPTION_SOURCE"] = "购买方式";
translations["MSG_PARENT_PAGE_EDUCATION_DESCRIPTION"] = "您正在使用企业合同。详情请联系管理员。";

// 家长页面 - 账号标签页
translations["MSG_PARENT_PAGE_ACCOUNT_INFO"] = "账号信息";
translations["MSG_PARENT_PAGE_NICKNAME"] = "昵称";
translations["MSG_PARENT_PAGE_ICON"] = "头像";
translations["MSG_PARENT_PAGE_EMAIL"] = "邮箱地址";
translations["MSG_PARENT_PAGE_EMAIL_VERIFIED"] = "邮箱验证";
translations["MSG_PARENT_PAGE_VERIFIED"] = "已验证";
translations["MSG_PARENT_PAGE_CREATED_AT"] = "注册日期";
translations["MSG_PARENT_PAGE_CHANGE"] = "更改";
translations["MSG_PARENT_PAGE_SNS_LINK"] = "账号绑定";
translations["MSG_PARENT_PAGE_GOOGLE_ACCOUNT"] = "Google账号";
translations["MSG_PARENT_PAGE_APPLE_ID"] = "Apple ID";
translations["MSG_PARENT_PAGE_LINK"] = "绑定";
translations["MSG_PARENT_PAGE_UNLINK"] = "解除绑定";

// 家长页面 - 个人资料部分
translations["MSG_PARENT_PAGE_PROFILE_SECTION_TITLE"] = "个人资料";
translations["MSG_PARENT_PAGE_PROFILE_EDIT_TITLE"] = "编辑个人资料";
translations["MSG_PARENT_PAGE_PROFILE_NOT_SET"] = "未设置";
translations["MSG_PARENT_PAGE_PROFILE_BASIC_INFO"] = "基本信息";
translations["MSG_PARENT_PAGE_PROFILE_REGION_PLACEHOLDER"] = "例如：上海市";
translations["MSG_PARENT_PAGE_PROFILE_CITY_PLACEHOLDER"] = "例如：浦东新区";
translations["MSG_PARENT_PAGE_PROFILE_NOTES"] = "自我介绍备注";
translations["MSG_PARENT_PAGE_TAB_BASIC"] = "基本信息";
translations["MSG_PARENT_PAGE_TAB_FAVORITES"] = "个性";
translations["MSG_PARENT_PAGE_TAB_APPEARANCE"] = "头像";
translations["MSG_PARENT_PAGE_NOT_SET"] = "未设置";
translations["MSG_PARENT_PAGE_EDIT_FAVORITE_COLOR"] = "编辑喜欢的颜色";
translations["MSG_PARENT_PAGE_EDIT_SELF_INTRO"] = "编辑自我介绍";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_SUCCESS"] = "个人资料更新成功";
translations["MSG_PARENT_PAGE_PROFILE_UPDATE_ERROR"] = "个人资料更新失败";

// 家长页面 - 头像编辑弹窗
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT"] = "当前";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED"] = "用这个？";
translations["MSG_ICON_CHANGE_CONFIRM_BTN"] = "确定";
translations["MSG_ICON_CHANGE_AI_CANCEL"] = "取消";
// AI使用限制
translations["MSG_QUOTA_EXCEEDED"] = "今天的次数用完啦！明天再来吧！";
translations["MSG_QUOTA_RESET_TIME"] = "明天0:00重置";
translations["MSG_AI_PROCESSING"] = "AI生成中...";

translations["MSG_PARENT_PAGE_ACCOUNT_ACTIONS"] = "账号操作";
translations["MSG_PARENT_PAGE_CHANGE_PASSWORD"] = "修改密码";
translations["MSG_PARENT_PAGE_LOGOUT"] = "退出登录";
// 家长页面 - 昵称编辑弹窗
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_TITLE"] = "修改昵称";
translations["MSG_PARENT_PAGE_NICKNAME_EDIT_MESSAGE"] = "请输入新的昵称";
translations["MSG_PARENT_PAGE_NICKNAME_ERROR_MESSAGE"] = "请尝试自我介绍名称";
// 家长页面 - 孩子管理标签页
translations["MSG_PARENT_PAGE_ADD"] = "添加";
translations["MSG_PARENT_PAGE_ACTIVE"] = "活跃";
translations["MSG_PARENT_PAGE_INACTIVE"] = "非活跃";
translations["MSG_PARENT_PAGE_PLAYABLE"] = "可游玩";
translations["MSG_PARENT_PAGE_SUSPENDED"] = "已暂停";
translations["MSG_PARENT_PAGE_SWITCH_LOGIN"] = "切换";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_TITLE"] = "无法切换";
translations["MSG_PARENT_PAGE_FROZEN_DIALOG_MESSAGE"] =
  "该玩家已停用，无法切换登录。请先激活玩家。";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_TITLE"] = "切换玩家？";
translations["MSG_PARENT_PAGE_SWITCH_CONFIRM_MESSAGE"] = "切换到「%{name}」。";
translations["MSG_PARENT_PAGE_BASIC_INFO"] = "基本信息";
translations["MSG_PARENT_PAGE_AGE"] = "年龄";
translations["MSG_PARENT_PAGE_YEARS_OLD"] = "岁";
translations["MSG_PARENT_PAGE_GENDER"] = "性别";
translations["MSG_PARENT_PAGE_BIRTHDAY"] = "生日";
translations["MSG_PARENT_PAGE_ACCOUNT_CREATED_DATE"] = "账号创建日期";
translations["MSG_GENDER_SELECT_TITLE"] = "请选择一个";
translations["MSG_GENDER_STATUS_LABEL"] = "性别";
translations["MSG_GENDER_NOT_SELECTED"] = "未选择";
translations["MSG_GENDER_MALE"] = "男孩";
translations["MSG_GENDER_FEMALE"] = "女孩";
translations["MSG_GENDER_NONE"] = "无";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_TITLE"] = "修改名字";
translations["MSG_PARENT_PAGE_CHILD_NAME_EDIT_MESSAGE"] = "请输入新名字";
translations["MSG_PARENT_PAGE_YEAR"] = "年";
translations["MSG_PARENT_PAGE_MONTH"] = "月";
translations["MSG_PARENT_PAGE_DAY"] = "日";
translations["MSG_PARENT_PAGE_GENDER_EDIT_TITLE"] = "修改性别";
translations["MSG_PARENT_PAGE_GENDER_EDIT_MESSAGE"] = "请选择性别";
translations["MSG_PARENT_PAGE_BIRTHDAY_EDIT_TITLE"] = "修改生日";
translations["MSG_PARENT_PAGE_COURSE_CLEAR"] = "课程完成";
translations["MSG_PARENT_PAGE_CREATED_PROJECTS"] = "创建的作品";
translations["MSG_PARENT_PAGE_PUBLISHED_PROJECTS"] = "已发布作品";
translations["MSG_PARENT_PAGE_RECEIVED_LIKES"] = "获得的点赞";
translations["MSG_PARENT_PAGE_SETTINGS"] = "设置";
translations["MSG_PARENT_PAGE_DISPLAY_LANGUAGE"] = "显示语言";
translations["MSG_PARENT_PAGE_HIRAGANA"] = "平假名";
translations["MSG_PARENT_PAGE_KANJI"] = "汉字";
translations["MSG_PARENT_PAGE_PROJECT_PUBLISH"] = "作品公开";
translations["MSG_PARENT_PAGE_COPY_PERMISSION"] = "复制许可";
translations["MSG_PARENT_PAGE_AI_CHAT"] = "与学伴君聊天";
translations["MSG_PARENT_PAGE_AI_GENERATION"] = "AI创作素材";
translations["MSG_PARENT_PAGE_ACCOUNT_STATUS"] = "账号状态";
translations["MSG_PARENT_PAGE_DANGER_ZONE"] = "危险操作";
translations["MSG_PARENT_PAGE_DELETE_CHILD_WARNING"] =
  "所有学习数据和作品将被删除。此操作无法撤销。";
translations["MSG_PARENT_PAGE_DELETE_CHILD"] = "删除此用户";
translations["MSG_PARENT_PAGE_DELETE_BTN"] = "删除";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY"] = "最近活动";
translations["MSG_PARENT_PAGE_NO_ACTIVITY_24H"] = "24小时内暂无活动";
translations["MSG_PARENT_PAGE_RECENT_ACTIVITY_24H"] = "最近24小时的活动";
translations["MSG_PARENT_PAGE_TODAY"] = "今天";
translations["MSG_PARENT_PAGE_YESTERDAY"] = "昨天";

// 家长页面 - 活动类型
translations["MSG_ACTIVITY_COURSE_CLEAR"] = "通关%{course}第%{stage}关 第%{level}级！";
translations["MSG_ACTIVITY_PROJECT_CREATED"] = "创建了「%{name}」";
translations["MSG_ACTIVITY_PROJECT_PUBLISHED"] = "发布了「%{name}」";
translations["MSG_ACTIVITY_PROJECT_FAVORITED"] = "点赞了「%{name}」";
translations["MSG_ACTIVITY_FAVORITED_RECEIVED"] = "收到了一个赞";
translations["MSG_ACTIVITY_LOGIN"] = "登录了";
translations["MSG_ACTIVITY_ICON_CHANGED"] = "更换了头像";
translations["MSG_ACTIVITY_AI_CHAT"] = "和AI聊天了";
translations["MSG_ACTIVITY_INQUIRY_SENT"] = "发送了问题反馈";
translations["MSG_ACTIVITY_APP_REVIEWED"] = "给应用评了★%{rating}";
translations["MSG_ACTIVITY_FEEDBACK_SENT"] = "发送了反馈";
translations["MSG_ACTIVITY_COIN_EARNED"] = "获得了%{amount}个金币";
translations["MSG_ACTIVITY_COIN_SPENT"] = "使用了%{amount}个金币";
translations["MSG_ACTIVITY_LOGIN_STREAK"] = "连续登录%{days}天！";
translations["MSG_ACTIVITY_DEFAULT"] = "活动";

// 家长页面 - 活动日志（家长专用）
translations["MSG_PARENT_PAGE_ACTIVITY_COURSE_CLEAR"] =
  "通过了%{course}的阶段%{stage} 等级%{level}！";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_CREATED"] = "创建了「%{name}」";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_PUBLISHED"] = "发布了「%{name}」";
translations["MSG_PARENT_PAGE_ACTIVITY_PROJECT_FAVORITED"] = "给「%{name}」点了赞";
translations["MSG_PARENT_PAGE_ACTIVITY_FAVORITED_RECEIVED"] = "收到了点赞";
translations["MSG_PARENT_PAGE_ACTIVITY_LOGIN"] = "登录了";
translations["MSG_PARENT_PAGE_ACTIVITY_ICON_CHANGED"] = "更换了头像";
translations["MSG_PARENT_PAGE_ACTIVITY_AI_CHAT"] = "和AI聊天了";
translations["MSG_PARENT_PAGE_ACTIVITY_INQUIRY_SENT"] = "发送了问题反馈";
translations["MSG_PARENT_PAGE_ACTIVITY_APP_REVIEWED"] = "给应用评了★%{rating}";
translations["MSG_PARENT_PAGE_ACTIVITY_FEEDBACK_SENT"] = "发送了反馈";
translations["MSG_PARENT_PAGE_ACTIVITY_DEFAULT"] = "活动";

// 家长页面 - 作品・素材部分
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS"] = "应用列表";
translations["MSG_PARENT_PAGE_PLAYER_PROJECTS_EMPTY"] = "还没有应用";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_LIST"] = "素材列表";
translations["MSG_PARENT_PAGE_PLAYER_ASSETS_EMPTY"] = "还没有素材";
translations["MSG_PARENT_PAGE_PLAYER_SHOW_MORE"] = "查看更多";
translations["MSG_PARENT_PAGE_PLAYER_ALBUM"] = "相册";
translations["MSG_PARENT_PAGE_PLAYER_SKETCHBOOK"] = "画板";
translations["MSG_PARENT_PAGE_PLAYER_AI_IMAGE"] = "AI图片";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_PUBLISHED"] = "已发布";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UNPUBLISHED"] = "未公开";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_VIEWS"] = "次浏览";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_LIKES"] = "个赞";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_COPIES"] = "次复制";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_CREATED"] = "创建日期";
translations["MSG_PARENT_PAGE_PLAYER_PROJECT_UPDATED"] = "更新日期";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_CREATED"] = "创建日期";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_SIZE"] = "尺寸";
translations["MSG_PARENT_PAGE_PLAYER_ASSET_UNNAMED"] = "未命名";

// 家长页面 - 反馈历史
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY"] = "反馈历史";
translations["MSG_PARENT_PAGE_FEEDBACK_HISTORY_EMPTY"] = "还没有反馈";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_RATING"] = "应用评价";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_FEEDBACK"] = "反馈";
translations["MSG_PARENT_PAGE_FEEDBACK_TYPE_CONTACT"] = "咨询";
translations["MSG_PARENT_PAGE_FEEDBACK_RATING_SUMMARY"] = "给应用评了★%{rating}";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_HOW_TO"] = "使用方法";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_BUG"] = "问题报告";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_REQUEST"] = "功能请求";
translations["MSG_PARENT_PAGE_CONTACT_TYPE_OTHER"] = "自我介绍";
translations["MSG_PARENT_PAGE_FEEDBACK_REPLIED"] = "已回复";
translations["MSG_PARENT_PAGE_FEEDBACK_PENDING"] = "未回复";
translations["MSG_PARENT_PAGE_FEEDBACK_DETAIL"] = "反馈详情";

// 家长页面 - AI聊天记录
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY"] = "AI聊天记录";
translations["MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY"] = "暂无聊天记录";
translations["MSG_PARENT_PAGE_AI_CHAT_MESSAGE_COUNT"] = "%{count}条消息";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_TITLE"] = "无标题";
translations["MSG_PARENT_PAGE_AI_CHAT_NO_MESSAGES"] = "暂无消息";

// 家长页面 - 订阅管理标签页
translations["MSG_PARENT_PAGE_CURRENT_PLAN"] = "当前方案";
translations["MSG_PARENT_PAGE_MONTHLY_PRICE"] = "月费";
translations["MSG_PARENT_PAGE_PLAN_COMPARISON"] = "方案对比";
translations["MSG_PARENT_PAGE_USER_COUNT"] = "玩家数";
translations["MSG_PARENT_PAGE_PEOPLE"] = "人";
translations["MSG_PARENT_PAGE_PROJECT_COUNT"] = '"自由创作"作品数';
translations["MSG_PARENT_PAGE_PROJECTS"] = "个作品";
translations["MSG_PARENT_PAGE_AI_CHAT_FEATURE"] = "与学伴君聊天";
translations["MSG_PARENT_PAGE_AI_IMAGE_FEATURE"] = "AI素材图像生成";
translations["MSG_PARENT_PAGE_AI_CHAT_FREE_LIMIT"] = "5次/日";
translations["MSG_PARENT_PAGE_AI_IMAGE_FREE_LIMIT"] = "2次/日";
translations["MSG_PARENT_PAGE_AI_CHAT_TAGLINE"] = "与AI角色愉快聊天！";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_1"] = "回答问题和咨询";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_2"] = "培养孩子好奇心的对话体验";
translations["MSG_PARENT_PAGE_AI_CHAT_BENEFIT_3"] = "可以讨论想法";
translations["MSG_PARENT_PAGE_AI_IMAGE_TAGLINE"] = "将想象变成图像！";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_1"] = "创建原创图标";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_2"] = "用于「自由创作」";
translations["MSG_PARENT_PAGE_AI_IMAGE_BENEFIT_3"] = "也可发送到聊天";
translations["MSG_PARENT_PAGE_UNLIMITED"] = "无限制";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FEATURE"] = "聊天记录";
translations["MSG_PARENT_PAGE_CHAT_HISTORY_FREE_LIMIT"] = "最多100条";
translations["MSG_PARENT_PAGE_AI_CHAT_STANDARD_LIMIT"] = "无限制";
translations["MSG_PARENT_PAGE_AI_CHAT_PREMIUM_LIMIT"] = "无限制";
translations["MSG_PARENT_PAGE_AI_IMAGE_STANDARD_LIMIT"] = "无限制（同时生成1张）";
translations["MSG_PARENT_PAGE_AI_IMAGE_PREMIUM_LIMIT"] = "无限制（同时生成3张）";
translations["MSG_PARENT_PAGE_FREE"] = "免费";
translations["MSG_PARENT_PAGE_PLAN_INFO"] = "套餐信息";
translations["MSG_PARENT_PAGE_UPGRADE_SECTION"] = "购买套餐";
translations["MSG_PARENT_PAGE_SELECT_BILLING_PERIOD"] = "选择订阅周期";
translations["MSG_PARENT_PAGE_ANNUAL_PRICE"] = "年费";

// 家长页面 - 自我介绍标签页
translations["MSG_PARENT_PAGE_DOWNLOAD_PARENTS_APP"] = "下载家长应用";
translations["MSG_PARENT_PAGE_APP_DESCRIPTION"] = "使用家长应用查看孩子的学习进度并管理设置。";
translations["MSG_PARENT_PAGE_LEARNING_SUPPORT"] = "学习支持";
translations["MSG_PARENT_PAGE_COURSE_ANSWER"] = "查看课程答案";
translations["MSG_PARENT_PAGE_VIEW_TUTORIAL"] = "查看教程";
translations["MSG_PARENT_PAGE_CORPORATE_CODE"] = "企业合作代码";
translations["MSG_PARENT_PAGE_ENABLE_CORPORATE"] = "输入企业认证代码";
translations["MSG_PARENT_PAGE_CORPORATE_DESCRIPTION"] = "如果您有企业合作代码，请在这里输入。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_DESCRIPTION"] =
  "如果您持有「乐学拼图」认证码（企业合作码），请在下方输入指定的代码。";
translations["MSG_PARENT_PAGE_CORPORATE_AUTH_CODE_INPUT"] = "输入认证码";
translations["MSG_PARENT_PAGE_CORPORATE_CONFIRM"] = "确定";
translations["MSG_PARENT_PAGE_CORPORATE_ALLOWED_CONTENT"] = "已授权的内容（卡带）";
translations["MSG_PARENT_PAGE_CORPORATE_NO_CONTENT"] = "没有已授权的追加内容（卡带）。";
translations["MSG_PARENT_PAGE_DATE_FORMAT"] = "MM月DD日";
// 家长页面 - 通知标签页（演示数据）
// AI预设
translations["MSG_AI_PRESET_CAT"] = "猫";
translations["MSG_AI_PRESET_DOG"] = "狗";
translations["MSG_AI_PRESET_RABBIT"] = "兔";
translations["MSG_AI_PRESET_BEAR"] = "熊";
translations["MSG_AI_PRESET_BIRD"] = "鸟";
translations["MSG_AI_PRESET_NINJA"] = "忍者";
translations["MSG_AI_PRESET_WIZARD"] = "魔法师";
translations["MSG_AI_PRESET_ROBOT"] = "机器人";

// AI生成选项（家长）
translations["MSG_OPTIONAL"] = "可选";
translations["MSG_REQUIRED"] = "必填";
// AI风格（9种）
translations["MSG_AI_STYLE_CYBERPUNK"] = "赛博朋克";
translations["MSG_AI_STYLE_ANIME"] = "动漫";
translations["MSG_AI_STYLE_DRAMATIC"] = "戏剧性肖像";
translations["MSG_AI_STYLE_COLORING"] = "涂色书";
translations["MSG_AI_STYLE_PHOTO"] = "摄影";
translations["MSG_AI_STYLE_RETRO_MANGA"] = "复古漫画";
translations["MSG_AI_STYLE_EIGHTIES"] = "80年代魅力";
translations["MSG_AI_STYLE_ART_NOUVEAU"] = "新艺术风格";
translations["MSG_AI_STYLE_SYNTHWAVE"] = "合成器波";

// AI表情（4种）
translations["MSG_AI_EXPRESSION_SMILE"] = "微笑";
translations["MSG_AI_EXPRESSION_COOL"] = "酷";
translations["MSG_AI_EXPRESSION_SLEEPY"] = "困倦";
translations["MSG_AI_EXPRESSION_SURPRISED"] = "惊讶";

// AI配饰（4种）
translations["MSG_AI_ACCESSORY_HAT"] = "帽子";
translations["MSG_AI_ACCESSORY_GLASSES"] = "眼镜";
translations["MSG_AI_ACCESSORY_RIBBON"] = "蝴蝶结";
translations["MSG_AI_ACCESSORY_CROWN"] = "皇冠";

// AI背景（4种）
translations["MSG_AI_BACKGROUND_STARRY"] = "星空";
translations["MSG_AI_BACKGROUND_MEADOW"] = "草原";
translations["MSG_AI_BACKGROUND_SPACE"] = "宇宙";
translations["MSG_AI_BACKGROUND_FLOWER"] = "花海";

// AI加工 - 类型
// AI加工 - 步骤标题
// AI加工 - 风格选项
// AI加工 - 背景选项
// AI加工 - 扮演选项
// AI加工 - 动物选项
// AI加工 - 配饰选项
// AI加工 - 季节选项
translations["MSG_TOAST_AI_GENERATION_FAILED"] = "AI图像生成失败。";
// AIImageModal
translations["MSG_AI_IMAGE_SAVED"] = "AI图像已保存到素材库";
translations["MSG_AI_TAB_GENERATE"] = "生成";
// CreateUserWizard - 按钮
translations["MSG_CREATE_USER_BTN_NEXT"] = "下一步";
translations["MSG_CREATE_USER_BTN_GENERATE"] = "创建头像";
// CreateUserWizard - 个人资料输入子步骤名称
translations["MSG_PROFILE_SUBSTEP_GENDER"] = "性别";
translations["MSG_PROFILE_SUBSTEP_BIRTHDAY"] = "生日";
translations["MSG_PROFILE_SUBSTEP_FAVORITES"] = "喜好";
translations["MSG_PROFILE_SUBSTEP_ICON"] = "头像";
translations["MSG_ICON_GENERATING"] = "正在根据个人资料\n制作头像...";
translations["MSG_ICON_CONFIRM_PROMPT"] = "这个头像可以吗？";
translations["MSG_ICON_CONFIRM_BTN"] = "好的！";
translations["MSG_ICON_REGENERATE_BTN"] = "再试一次";
translations["MSG_ICON_CREATE_BTN"] = "创建";
translations["MSG_ICON_ADDITIONAL_PROMPT_PLACEHOLDER"] = "如果想添加什么";
translations["MSG_ICON_ADDITIONAL_PROMPT_HINT"] = "输入喜欢的颜色或东西，再做一个新头像！";

// CreateUserWizard - 个人资料输入标题
// CreateUserWizard - 自我介绍
// CreateUserWizard - 步骤标题（儿童用基础）
translations["MSG_CREATE_USER_TITLE_GENDER"] = "你是哪个？";
translations["MSG_CREATE_USER_TITLE_BIRTHDAY"] = "你的生日是什么时候？";
translations["MSG_CREATE_USER_TITLE_PREVIEW"] = "这样可以吗？";

// CreateUserWizard - 家长用/添加儿童用文案
// CreateUserWizard - 家长用按钮
// CreateUserWizard - 上传头像（家长用）
translations["MSG_ICON_SELECT_UPLOAD"] = "上传图片";
translations["MSG_UPLOAD_ICON_TITLE"] = "上传图片";
translations["MSG_UPLOAD_ICON_SELECT"] = "选择图片";
translations["MSG_UPLOAD_ICON_HINT"] = "JPG、PNG格式，最大5MB";
translations["MSG_UPLOAD_ICON_CHANGE"] = "更换图片";
translations["MSG_UPLOAD_ICON_REMOVE"] = "删除图片";
// CreateUserWizard - 职业步骤（家长用）
// 个人资料标签
translations["MSG_PROFILE_TAB_BASIC"] = "基本";
translations["MSG_PROFILE_TAB_APPEARANCE"] = "头像";
translations["MSG_PROFILE_TAB_FAVORITES"] = "个性";
translations["MSG_PROFILE_TAB_GAME_CASE"] = "游戏\n外壳";
translations["MSG_PROFILE_MULTI_SELECT"] = "可以选多个哦";
translations["MSG_PROFILE_NOT_SET"] = "还没选哦";
translations["MSG_PROFILE_SELF_INTRODUCTION_NOT_SET"] = "还没输入哦";
translations["MSG_PROFILE_CHANGE_BTN"] = "更改";
translations["MSG_PROFILE_EDIT_COLOR_TITLE"] = "选择喜欢的颜色";
translations["MSG_PROFILE_EDIT_BEST_SUBJECTS_TITLE"] = "选择你擅长的科目";
translations["MSG_SELECT_PLACEHOLDER"] = "请选择";

// CreateUserWizard - 喜好步骤
translations["MSG_PROFILE_AI_FAVORITE_COLOR"] = "喜欢的颜色";
translations["MSG_PROFILE_AI_FAVORITE_ANIMAL"] = "喜欢的动物";
translations["MSG_PROFILE_AI_FAVORITE_FOOD"] = "喜欢的食物";
translations["MSG_PROFILE_AI_STRENGTH"] = "擅长什么";
translations["MSG_PROFILE_AI_OTHER_INFO"] = "自我介绍";
translations["MSG_PROFILE_AI_OTHER_INFO_PLACEHOLDER"] = "告诉我们关于你的事情";
translations["MSG_PROFILE_AI_BEST_SUBJECTS"] = "擅长的科目";
translations["MSG_PROFILE_AI_GLASSES"] = "眼镜";
translations["MSG_PROFILE_AI_ACCESSORY"] = "配饰";
translations["MSG_PROFILE_AI_HAIRSTYLE"] = "发型";
translations["MSG_PROFILE_AI_BODY_TYPE"] = "体型";
translations["MSG_PROFILE_AI_FACE_SHAPE"] = "脸型";
translations["MSG_PROFILE_EDIT_ACCESSORY_TITLE"] = "选择配饰";
// 配饰选项
translations["MSG_ACCESSORY_NONE"] = "无";
translations["MSG_ACCESSORY_MEGANE"] = "眼镜";
translations["MSG_ACCESSORY_BOUSHI"] = "帽子";
translations["MSG_ACCESSORY_HAIRPIN"] = "发夹";
translations["MSG_ACCESSORY_RIBBON"] = "蝴蝶结";
translations["MSG_ACCESSORY_BANDAID"] = "创可贴";

// 颜色
translations["MSG_COLOR_RED"] = "红色";
translations["MSG_COLOR_BLUE"] = "蓝色";
translations["MSG_COLOR_PINK"] = "粉色";
translations["MSG_COLOR_GREEN"] = "绿色";
translations["MSG_COLOR_YELLOW"] = "黄色";
translations["MSG_COLOR_PURPLE"] = "紫色";
translations["MSG_COLOR_WHITE"] = "白色";

// 颜色选择UI
translations["MSG_COLOR_SELECT_SHADE"] = "选择你喜欢的色调";

// 动物
translations["MSG_ANIMAL_CAT"] = "猫";
translations["MSG_ANIMAL_DOG"] = "狗";
translations["MSG_ANIMAL_RABBIT"] = "兔子";
translations["MSG_ANIMAL_BEAR"] = "熊";
translations["MSG_ANIMAL_BIRD"] = "鸟";
translations["MSG_ANIMAL_DINOSAUR"] = "恐龙";

// 食物
translations["MSG_FOOD_CURRY"] = "咖喱";
translations["MSG_FOOD_RAMEN"] = "拉面";
translations["MSG_FOOD_SUSHI"] = "寿司";
translations["MSG_FOOD_HAMBURGER"] = "汉堡";
translations["MSG_FOOD_PIZZA"] = "披萨";
translations["MSG_FOOD_ICE_CREAM"] = "冰淇淋";
translations["MSG_FOOD_FRUIT"] = "水果";
translations["MSG_FOOD_CAKE"] = "蛋糕";

// 特长
translations["MSG_STRENGTH_SPORTS"] = "运动";
translations["MSG_STRENGTH_DRAWING"] = "画画";
translations["MSG_STRENGTH_MUSIC"] = "音乐";
translations["MSG_STRENGTH_READING"] = "阅读";
translations["MSG_STRENGTH_MATH"] = "数学";
translations["MSG_STRENGTH_GAMES"] = "游戏";
translations["MSG_STRENGTH_CRAFTS"] = "手工";
translations["MSG_STRENGTH_COOKING"] = "烹饪";

// 兴趣
translations["MSG_INTEREST_PROGRAMMING"] = "编程";
translations["MSG_INTEREST_SCIENCE"] = "科学";
translations["MSG_INTEREST_ART"] = "艺术";
translations["MSG_INTEREST_MUSIC"] = "音乐";
translations["MSG_INTEREST_SPORTS"] = "运动";
translations["MSG_INTEREST_NATURE"] = "自然";
translations["MSG_INTEREST_SPACE"] = "太空";
translations["MSG_INTEREST_ANIMALS"] = "动物";

// 科目
translations["MSG_SUBJECT_LANGUAGE"] = "语文";
translations["MSG_SUBJECT_MATH"] = "数学";
translations["MSG_SUBJECT_SCIENCE"] = "科学";
translations["MSG_SUBJECT_SOCIAL"] = "社会";
translations["MSG_SUBJECT_MUSIC"] = "音乐";
translations["MSG_SUBJECT_ART"] = "美术";
translations["MSG_SUBJECT_PE"] = "体育";
translations["MSG_SUBJECT_LIFE"] = "生活";
translations["MSG_SUBJECT_HOME_EC"] = "家政";
translations["MSG_SUBJECT_ETHICS"] = "道德";
translations["MSG_SUBJECT_ENGLISH"] = "英语";
translations["MSG_SUBJECT_INTEGRATED"] = "综合";
translations["MSG_SUBJECT_SPECIAL_ACTIVITIES"] = "活动";

// 外观选项
translations["MSG_GLASSES_NONE"] = "无";
translations["MSG_GLASSES_YES"] = "有";
translations["MSG_HAIRSTYLE_VERY_SHORT"] = "很短";
translations["MSG_HAIRSTYLE_SHORT"] = "短";
translations["MSG_HAIRSTYLE_MEDIUM"] = "中等";
translations["MSG_HAIRSTYLE_SLIGHTLY_LONG"] = "略长";
translations["MSG_HAIRSTYLE_LONG"] = "长";
translations["MSG_BODY_TYPE_THIN"] = "瘦";
translations["MSG_BODY_TYPE_SLIGHTLY_THIN"] = "偏瘦";
translations["MSG_BODY_TYPE_MEDIUM"] = "中等";
translations["MSG_BODY_TYPE_SLIGHTLY_CHUBBY"] = "微胖";
translations["MSG_BODY_TYPE_CHUBBY"] = "偏胖";
translations["MSG_FACE_SHAPE_ROUND"] = "圆脸";
translations["MSG_FACE_SHAPE_OVAL"] = "鹅蛋脸";
translations["MSG_FACE_SHAPE_OBLONG"] = "长脸";
translations["MSG_FACE_SHAPE_SQUARE"] = "方脸";
translations["MSG_FACE_SHAPE_TRIANGLE"] = "三角脸";

// CreateUserWizard - 家长用步骤名称
// CreateUserWizard - 个人资料子步骤（家长用）
// CreateUserWizard - 生日分步选择（儿童用）
translations["MSG_BIRTHDAY_YEAR_SUFFIX"] = "年";
translations["MSG_BIRTHDAY_MONTH_SUFFIX"] = "月";
translations["MSG_BIRTHDAY_DAY_SUFFIX"] = "日";
// 页脚按钮
// NameInputStep
// PresetIconStep 标签
// BirthdayStep 后缀
// FavoritesStep
// 颜色选项
// 动物选项
// 食物选项
// 特长选项
// 兴趣选项
// IconPreviewStep
// StepProgressBar
// ProfileSubStepBar

// AI Image Generation - Usage count (FREE)
translations["MSG_AI_IMAGE_PLAN_LABEL"] = "套餐";
translations["MSG_AI_IMAGE_USAGE_TODAY"] = "今天 %{remaining}/%{limit}次";
translations["MSG_AI_IMAGE_UNLIMITED"] = "无限使用";
translations["MSG_AI_IMAGE_COUNT_PER_REQUEST"] = "每次%{count}张";

// ParentOnboardingModal - 家长引导
translations["MSG_PARENT_ONBOARDING_NAME_PLACEHOLDER"] = "昵称";
translations["MSG_PARENT_ONBOARDING_NICKNAME_TITLE"] = "请输入昵称";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_LIMIT"] = "最多10个字符";
translations["MSG_PARENT_ONBOARDING_NICKNAME_LENGTH_ERROR"] = "请输入10个字符以内";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET"] = "从预设中选择";
translations["MSG_PARENT_ONBOARDING_ICON_PRESET_TITLE"] = "请选择头像";
translations["MSG_PARENT_ONBOARDING_REGION_TITLE"] = "您的所在地区";
translations["MSG_TOAST_FILE_TOO_LARGE"] = "文件太大";

// CreateUserWizard - 个人资料"自我介绍"输入栏

translations["MSG_ICON_SELECT_TITLE"] = "选择你的头像！";
translations["MSG_ICON_SELECT_SYSTEM"] = "预设\n头像";
translations["MSG_ICON_SELECT_SYSTEM_DESC"] = "从各种角色中选择";
translations["MSG_ICON_SELECT_PROFILE_AI"] = "用AI从\n个人资料\n创建";
translations["MSG_ICON_SELECT_PROFILE_AI_DESC"] = "输入你的喜好我们会创建";
translations["MSG_ICON_SELECT_MATERIAL"] = "从素材\n中选择";
translations["MSG_ICON_SELECT_MATERIAL_DESC"] = "你也可以上传图片";
translations["MSG_SYSTEM_ICON_TITLE"] = "从预设中选择";
translations["MSG_ICON_CATEGORY_ALL"] = "全部";
translations["MSG_ICON_CATEGORY_BOY"] = "男孩";
translations["MSG_ICON_CATEGORY_GIRL"] = "女孩";
translations["MSG_PROFILE_AI_APPEARANCE"] = "外貌";
translations["MSG_PROFILE_AI_BEST_SUBJECT"] = "擅长科目";
translations["MSG_GLASSES_TITLE"] = "眼镜";
translations["MSG_HAIRSTYLE_TITLE"] = "发型";
translations["MSG_BODY_TYPE_TITLE"] = "体型";
translations["MSG_FACE_SHAPE_TITLE"] = "脸型";
translations["MSG_CREATE_USER_STEP_NAME"] = "名字";
translations["MSG_CREATE_USER_STEP_ICON"] = "头像";
translations["MSG_CREATE_USER_STEP_CONFIRM"] = "确认";
translations["MSG_REGENERATE_BTN"] = "重新创建";
translations["MSG_PROFILE_AI_GENERATE_BTN"] = "创建头像！";
translations["MSG_PROFILE_AI_GENERATING"] = "正在创建...";
translations["MSG_PROFILE_AI_GENDER_TITLE"] = "性别";
translations["MSG_PROFILE_AI_OPTIONS_TITLE"] = "偏好";
translations["MSG_PROFILE_AI_BIRTHDAY_TITLE"] = "生日";
translations["MSG_PROFILE_AI_BIRTHDAY_SELECT"] = "选择";
translations["MSG_PROFILE_AI_OCCUPATION"] = "职业";
translations["MSG_PROFILE_AI_OCCUPATION_PLACEHOLDER"] = "例如：上班族、自由职业";
translations["MSG_PROFILE_AI_FAVORITE_COLOR_PARENT"] = "喜欢的颜色";
translations["MSG_AI_MATERIAL_MODAL_TITLE"] = "创建AI图像！";
translations["MSG_AI_MATERIAL_PROMPT_LABEL"] = "创建什么？";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_1"] = "可爱的狗";
translations["MSG_AI_MATERIAL_PROMPT_PLACEHOLDER_2"] = "开心地跑";
translations["MSG_AI_MATERIAL_GENERATE_BUTTON"] = "创建！";
translations["MSG_AI_EDUCATION_LIMIT_TITLE"] = "不可用";
translations["MSG_AI_EDUCATION_LIMIT_MESSAGE"] = "教室计划中无法使用此功能";
translations["MSG_USER_STOCK_AI_TAB"] = "AI工作室";
translations["MSG_USER_STOCK_AI_TITLE"] = "AI工作室";
translations["MSG_USER_STOCK_AI_HINT"] = "用AI创建的图像";
translations["MSG_USER_STOCK_AI_EMPTY"] = "还没有AI图像";
translations["MSG_USER_PROFILE_EDIT_BTN"] = "编辑";
translations["MSG_USER_PROFILE_INPUT_NAME_PROMPT"] = "请输入名字";
translations["MSG_TOAST_PROJECT_QUOTA_EXCEEDED"] = "已达到应用上限";
translations["MSG_CREATOR_APP_LIMIT"] = "无法创建应用";
translations["MSG_CREATOR_APP_LIMIT_TITLE"] = "无法创建应用";
translations["MSG_CREATOR_APP_LIMIT_MESSAGE"] =
  "当前方案最多可创建%{limit}个应用\n如需创建新应用，请删除已有应用";
translations["MSG_CREATOR_TUTORIAL_LIMIT"] = "无法运行指南";
translations["MSG_CREATOR_TUTORIAL_LIMIT_TITLE"] = "无法运行指南";
translations["MSG_CREATOR_TUTORIAL_LIMIT_MESSAGE"] =
  "当前方案最多可创建%{limit}个应用\n如需运行指南，请删除已有应用";
translations["MSG_TOAST_AI_QUOTA_EXCEEDED"] = "今天的AI已用完";
translations["MSG_TOAST_AI_ACCESS_DENIED"] = "此功能不可用";
translations["MSG_TOAST_ERROR"] = "发生错误";
translations["MSG_ERROR_NETWORK"] = "网络错误";
translations["MSG_GENDER_MALE_PARENT"] = "男";
translations["MSG_GENDER_FEMALE_PARENT"] = "女";
translations["MSG_GENDER_OTHER_PARENT"] = "其他";
translations["MSG_GENDER_PREFER_NOT_TO_SAY"] = "不愿透露";
translations["MSG_GENDER_NOT_SPECIFIED"] = "未指定";
translations["MSG_ICON_CHANGE_PREVIEW_CURRENT_PARENT"] = "当前";
translations["MSG_ICON_CHANGE_PREVIEW_SELECTED_PARENT"] = "已选择";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_TITLE"] = "更改语言";
translations["MSG_PARENT_PAGE_LANGUAGE_EDIT_MESSAGE"] = "选择显示语言";
translations["MSG_PARENT_PAGE_EDIT_BEST_SUBJECT"] = "编辑擅长科目";
translations["MSG_PARENT_PAGE_EDIT_GLASSES"] = "编辑眼镜";
translations["MSG_PARENT_PAGE_EDIT_HAIRSTYLE"] = "编辑发型";
translations["MSG_PARENT_PAGE_EDIT_BODY_TYPE"] = "编辑体型";
translations["MSG_PARENT_PAGE_EDIT_FACE_SHAPE"] = "编辑脸型";
translations["MSG_SUBJECT_JAPANESE"] = "日语";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_TITLE"] = "无法添加用户";
translations["MSG_PARENT_PAGE_ADD_CHILD_LIMIT_MESSAGE"] = "已达到最大用户数";
translations["MSG_PARENT_PAGE_DELETE_CHILD_TITLE"] = "删除用户？";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MESSAGE"] = "此操作无法撤销";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_TITLE"] = "无法删除用户";
translations["MSG_PARENT_PAGE_DELETE_CHILD_MIN_MESSAGE"] = "至少需要一个用户";
translations["MSG_SUBSCRIPTION_STORE_MANAGE_TITLE"] = "订阅管理";
translations["MSG_SUBSCRIPTION_MANAGE_APP_STORE_MESSAGE"] = "请在App Store管理您购买的订阅";
translations["MSG_SUBSCRIPTION_MANAGE_PLAY_STORE_MESSAGE"] = "请在Google Play管理您购买的订阅";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_TITLE"] = "在其他平台购买";
translations["MSG_SUBSCRIPTION_PLATFORM_MISMATCH_MESSAGE"] = "此订阅是在其他平台购买的";
translations["MSG_PARENT_PAGE_BILLING_PERIOD"] = "计费周期";
translations["MSG_SUBSCRIPTION_MONTHLY_LABEL"] = "月付";
translations["MSG_SUBSCRIPTION_ANNUAL_LABEL"] = "年付";
translations["MSG_SUBSCRIPTION_MANAGE"] = "管理订阅";
translations["MSG_SUBSCRIPTION_COMPARISON_RECOMMENDED"] = "推荐";
translations["MSG_PARENT_ONBOARDING_STEP_NAME"] = "名字";
translations["MSG_PARENT_ONBOARDING_STEP_ICON"] = "头像";
translations["MSG_PARENT_ONBOARDING_STEP_COMPLETE"] = "确认";
translations["MSG_PARENT_PROFILE_APPEARANCE"] = "头像";
translations["MSG_PARENT_PROFILE_WORK"] = "工作";
translations["MSG_PARENT_PROFILE_REGION"] = "地区";
translations["MSG_PARENT_PROFILE_FAMILY"] = "家庭";
translations["MSG_HOUSEHOLD_MEMBER_MOTHER"] = "妈妈";
translations["MSG_HOUSEHOLD_MEMBER_FATHER"] = "爸爸";
translations["MSG_HOUSEHOLD_MEMBER_GRANDMOTHER"] = "奶奶";
translations["MSG_HOUSEHOLD_MEMBER_GRANDFATHER"] = "爷爷";
translations["MSG_COMPANY_SIZE_TITLE"] = "公司规模";
translations["MSG_INDUSTRY_TITLE"] = "行业";
translations["MSG_OCCUPATION_TITLE"] = "职业";
translations["MSG_JOB_TITLE_LABEL"] = "职位";
translations["MSG_JOB_TITLE_EXECUTIVE"] = "经营者・高管";
translations["MSG_JOB_TITLE_MANAGER"] = "管理职";
translations["MSG_JOB_TITLE_GENERAL"] = "一般职员";
translations["MSG_JOB_TITLE_PROFESSIONAL"] = "专业职";
translations["MSG_JOB_TITLE_HOMEMAKER"] = "无职位（家庭主妇／主夫）";
translations["MSG_JOB_TITLE_STUDENT"] = "无职位（学生）";
translations["MSG_JOB_TITLE_UNEMPLOYED"] = "无职位（无业）";
translations["MSG_PREFECTURE_TITLE"] = "省份";
translations["MSG_CITY_TITLE"] = "城市";
translations["MSG_HOUSEHOLD_MEMBERS_TITLE"] = "家庭成员";
translations["MSG_BOYS_COUNT"] = "男孩";
translations["MSG_GIRLS_COUNT"] = "女孩";
translations["MSG_PARENT_ONBOARDING_INCOME_TITLE"] = "年收入";
translations["MSG_PARENT_ONBOARDING_INCOME_UNDER_3M"] = "300万日元以下";
translations["MSG_PARENT_ONBOARDING_INCOME_3M_5M"] = "300-500万日元";
translations["MSG_PARENT_ONBOARDING_INCOME_5M_7M"] = "500-700万日元";
translations["MSG_PARENT_ONBOARDING_INCOME_7M_10M"] = "700-1000万日元";
translations["MSG_PARENT_ONBOARDING_INCOME_10M_15M"] = "1000-1500万日元";
translations["MSG_PARENT_ONBOARDING_INCOME_OVER_15M"] = "1500万日元以上";
translations["MSG_PARENT_ONBOARDING_INCOME_PREFER_NOT_TO_SAY"] = "不愿透露";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_TITLE"] = "自我介绍";
translations["MSG_PARENT_ONBOARDING_OTHER_INFO_PLACEHOLDER"] = "爱好、特长、孩子年龄等";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_SINGLE"] = "单亲";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_COUPLE"] = "夫妻";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_NUCLEAR"] = "核心家庭";
translations["MSG_PARENT_ONBOARDING_FAMILY_STRUCTURE_EXTENDED"] = "大家庭";
translations["MSG_PARENT_ONBOARDING_HOBBIES_SPORTS"] = "运动";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MUSIC"] = "音乐";
translations["MSG_PARENT_ONBOARDING_HOBBIES_READING"] = "阅读";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TRAVEL"] = "旅行";
translations["MSG_PARENT_ONBOARDING_HOBBIES_COOKING"] = "烹饪";
translations["MSG_PARENT_ONBOARDING_HOBBIES_GAMING"] = "游戏";
translations["MSG_PARENT_ONBOARDING_HOBBIES_OUTDOOR"] = "户外";
translations["MSG_PARENT_ONBOARDING_HOBBIES_ART"] = "艺术";
translations["MSG_PARENT_ONBOARDING_HOBBIES_MOVIES"] = "电影";
translations["MSG_PARENT_ONBOARDING_HOBBIES_PHOTOGRAPHY"] = "摄影";
translations["MSG_PARENT_ONBOARDING_GENDER_MALE"] = "男";
translations["MSG_PARENT_ONBOARDING_GENDER_FEMALE"] = "女";
translations["MSG_PARENT_ONBOARDING_GENDER_NONE"] = "未指定";
translations["MSG_PARENT_ONBOARDING_ICON_METHOD_TITLE"] = "选择头像方式";
translations["MSG_PARENT_ONBOARDING_ICON_UPLOAD"] = "上传图片";
translations["MSG_PARENT_ONBOARDING_ICON_PROFILE_AI"] = "用AI创建";
translations["MSG_PARENT_ONBOARDING_GENDER_TITLE"] = "性别";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_TITLE"] = "生日";
translations["MSG_PARENT_ONBOARDING_BIRTHDAY_SELECT"] = "选择";
translations["MSG_PARENT_ONBOARDING_UPLOAD_TITLE"] = "上传图片";
translations["MSG_PARENT_ONBOARDING_UPLOAD_SELECT"] = "选择图片";
translations["MSG_PARENT_ONBOARDING_UPLOAD_HINT"] = "JPG、PNG格式，最大5MB";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_TITLE"] = "职业（可选）";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_OPTIONAL"] = "可选";
translations["MSG_PARENT_ONBOARDING_OCCUPATION_PLACEHOLDER"] = "例如：上班族";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_TITLE"] = "公司";
translations["MSG_PARENT_ONBOARDING_ORGANIZATION_PLACEHOLDER"] = "公司名称";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_TITLE"] = "职位";
translations["MSG_PARENT_ONBOARDING_JOB_TITLE_PLACEHOLDER"] = "例如：经理";
translations["MSG_PARENT_ONBOARDING_FAMILY_TITLE"] = "家庭结构";
translations["MSG_PARENT_ONBOARDING_CHILDREN_COUNT_TITLE"] = "子女数量";
translations["MSG_PARENT_ONBOARDING_SPOUSE_TITLE"] = "配偶";
translations["MSG_PARENT_ONBOARDING_SPOUSE_YES"] = "是";
translations["MSG_PARENT_ONBOARDING_SPOUSE_NO"] = "否";
translations["MSG_PARENT_ONBOARDING_HOBBIES_TITLE"] = "爱好";
translations["MSG_PARENT_ONBOARDING_HOBBIES_HINT"] = "选择所有适用的";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_GENERATING"] = "正在创建头像...";
translations["MSG_PARENT_ONBOARDING_ICON_PREVIEW_CONFIRM"] = "这个头像可以吗？";
translations["MSG_PARENT_ONBOARDING_BTN_NEXT"] = "下一步";
translations["MSG_PARENT_ONBOARDING_BTN_GENERATE"] = "创建";
translations["MSG_PARENT_ONBOARDING_BTN_REGENERATE"] = "重新创建";
translations["MSG_PARENT_ONBOARDING_BTN_CONFIRM"] = "确认";
translations["MSG_PARENT_ONBOARDING_BTN_BACK"] = "返回";
translations["MSG_PARENT_ONBOARDING_BTN_COMPLETE"] = "完成";

// 家长页面 - 聊天图片功能限制
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_TITLE"] = "关于图片功能";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_MESSAGE"] =
  "发送图片需要「特别计划」\n升级到特别计划后可以发送图片";
translations["MSG_PARENTS_CHAT_IMAGE_RESTRICTION_BTN"] = "查看计划";

translations["MSG_AI_LABEL"] = "AI";
translations["MSG_BUILDER_AI_GENERATE_BTN"] = "自动生成";
translations["MSG_BUILDER_MAP_NAME_PLACEHOLDER"] = "拼图名称";
translations["MSG_BUILDER_TEST_BTN"] = "测试";
translations["MSG_BUILDER_ASSET_LIST_TITLE"] = "选择方块";
translations["MSG_BUILDER_ASSET_LIST_SHORT"] = "全部";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION"] = "装饰";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND"] = "地面";
translations["MSG_BUILDER_ASSET_CATEGORY_GROUND_HINT"] = "可以走在上面。台阶可以跳上去。";
translations["MSG_BUILDER_ASSET_CATEGORY_WATER"] = "水";
translations["MSG_BUILDER_ASSET_CATEGORY_WATER_HINT"] = "会掉下去。请跳过去。";
translations["MSG_BUILDER_ASSET_CATEGORY_DECORATION_HINT"] = "无法通过。请绕道。";
translations["MSG_BUILDER_ASSET_CATEGORY_GEM"] = "物品";
translations["MSG_BUILDER_ASSET_CATEGORY_GEM_HINT"] = "把它们全部收集起来。";
translations["MSG_BUILDER_ASSET_PLACE_ON_TILE"] = "可以放在地图的方格上";
translations["MSG_BUILDER_ASSET_PLACE_ON_GROUND"] = "可以放在地面上";
translations["MSG_BUILDER_ASSET_CATEGORY_BUTTON"] = "开关";
translations["MSG_BUILDER_ASSET_CATEGORY_BUTTON_HINT"] = "按颜色区分。踩上去会改变高度。";
translations["MSG_BUILDER_COMMAND_SETTINGS_TITLE"] = "可用命令";
translations["MSG_BUILDER_COMMAND_CATEGORY_MOTION"] = "动作";
translations["MSG_BUILDER_COMMAND_CATEGORY_CONTROL"] = "循环";
translations["MSG_BUILDER_COMMAND_MOVE_FORWARD"] = "向前移动";
translations["MSG_BUILDER_COMMAND_TURN_LEFT"] = "向左转";
translations["MSG_BUILDER_COMMAND_TURN_RIGHT"] = "向右转";
translations["MSG_BUILDER_COMMAND_JUMP"] = "跳跃";
translations["MSG_BUILDER_COMMAND_LOOP"] = "重复○次";
translations["MSG_BUILDER_COMMAND_IF_COLOR"] = "如果颜色是○";
translations["MSG_BUILDER_COMMAND_WHILE_COLOR"] = "重复直到颜色为○";
translations["MSG_BUILDER_COMMAND_SELECTED_COUNT"] = "已选择%{count}个命令";
translations["MSG_BUILDER_COMMAND_LIMIT_UNLIMITED"] = "无限制";
translations["MSG_BUILDER_COMMAND_LIMIT_COUNT"] = "最多%{count}个";
translations["MSG_BUILDER_PREVIEW_REMAINING"] = "剩余";
translations["MSG_BUILDER_PREVIEW_UNLIMITED"] = "不限";
translations["MSG_OK_BTN"] = "OK";
translations["MSG_BUILDER_AI_MAP_TITLE"] = "用AI制作地图";
translations["MSG_BUILDER_AI_PROMPT_LABEL"] = "想做什么样的地图？（可不填）";
translations["MSG_BUILDER_AI_PROMPT_PLACEHOLDER"] = "例如：像迷宫一样的关卡";
translations["MSG_BUILDER_DIFFICULTY_LABEL"] = "难度";
translations["MSG_BUILDER_DIFFICULTY_EASY"] = "简单";
translations["MSG_BUILDER_DIFFICULTY_MEDIUM"] = "普通";
translations["MSG_BUILDER_DIFFICULTY_HARD"] = "困难";
translations["MSG_BUILDER_AI_GENERATING"] = "正在生成...";
translations["MSG_BUILDER_AI_GENERATION_FAILED"] = "地图生成失败";
// 拼图编辑器: PublishStepsPanel (spec §5.8.3)
translations["MSG_BUILDER_PUBLISH_PANEL_TITLE"] = "完成准备";
translations["MSG_BUILDER_PUBLISH_PROGRESS_DONE"] = "这就完成啦！";
translations["MSG_BUILDER_STEP_CHARACTER"] = "角色";
translations["MSG_BUILDER_STEP_GOAL"] = "终点";
translations["MSG_BUILDER_STEP_COMMANDS"] = "命令";
translations["MSG_BUILDER_STEP_TEST"] = "测试";
translations["MSG_BUILDER_STEP_META"] = "拼图信息";
translations["MSG_BUILDER_META_NAME_LABEL"] = "名称";
translations["MSG_BUILDER_META_DESC_LABEL"] = "说明";
translations["MSG_BUILDER_META_DESC_PLACEHOLDER"] = "介绍一下你的拼图吧";
translations["MSG_BUILDER_META_DESC_MIN"] = "还差%{count}个字";
translations["MSG_BUILDER_META_DETAIL_BTN"] = "详细";
translations["MSG_BUILDER_STEP_COMMANDS_COUNT"] = "已设置%{count}个";
translations["MSG_BUILDER_STEP_BTN_PLACE"] = "放置";
translations["MSG_BUILDER_STEP_BTN_SETTING"] = "设置";
translations["MSG_BUILDER_STEP_BTN_RETRY"] = "再来一次";
translations["MSG_BUILDER_STEP_BTN_EDIT"] = "编辑";
translations["MSG_BUILDER_EDIT_HISTORY"] = "修改记录";
translations["MSG_BUILDER_EDIT_HISTORY_SHORT"] = "记录";
translations["MSG_BUILDER_SELECTED_ASSET"] = "选中的方块";
translations["MSG_BUILDER_EDIT_HISTORY_EMPTY"] = "还没有记录";
translations["MSG_BUILDER_EDIT_HISTORY_RESTORE"] = "还原";
translations["MSG_BUILDER_EDIT_HISTORY_NOW"] = "现在";
translations["MSG_BUILDER_EDIT_HISTORY_RESTORE_CONFIRM_TITLE"] = "还原到这里";
translations["MSG_BUILDER_EDIT_HISTORY_RESTORE_CONFIRM_MSG"] = "将作业还原到这个时间点。确定吗？";
translations["MSG_BUILDER_HISTORY_ACTION_PLACE_ASSET"] = "放置了方块";
translations["MSG_BUILDER_HISTORY_ACTION_REMOVE_ASSET"] = "删除了方块";
translations["MSG_BUILDER_HISTORY_ACTION_RESIZE_MAP"] = "改变了大小";
translations["MSG_BUILDER_HISTORY_ACTION_SET_GOAL"] = "设置了终点";
translations["MSG_BUILDER_HISTORY_ACTION_SET_CHARACTER"] = "放置了角色";
translations["MSG_BUILDER_HISTORY_ACTION_AI_GENERATE"] = "用AI制作";
translations["MSG_BUILDER_HISTORY_ACTION_RENAME"] = "修改了名称";
translations["MSG_BUILDER_HISTORY_ACTION_RESTORE"] = "已还原到此处";
translations["MSG_BUILDER_HISTORY_EVENT_COMPLETE"] = "完成";
translations["MSG_BUILDER_HISTORY_EVENT_PUBLISH"] = "已公开";
translations["MSG_BUILDER_HISTORY_EVENT_UNPUBLISH"] = "已取消公开";
translations["MSG_BUILDER_HISTORY_ACTION_CHANGE_ASSET"] = "修改了方块";
translations["MSG_BUILDER_HISTORY_ACTION_UNDO"] = "撤销了";
translations["MSG_BUILDER_HISTORY_ACTION_REDO"] = "重做了";
translations["MSG_BUILDER_HISTORY_ACTION_UNDO_OF"] = "撤销了：%{action}";
translations["MSG_BUILDER_HISTORY_ACTION_REDO_OF"] = "重做了：%{action}";
translations["MSG_BUILDER_HISTORY_EVENT_OPEN"] = "打开了拼图";
translations["MSG_BUILDER_HISTORY_EVENT_CLOSE"] = "关闭了拼图";
translations["MSG_BUILDER_HISTORY_EVENT_DISCARD"] = "放弃了草稿";
translations["MSG_BUILDER_EDIT_HISTORY_LIMIT_NOTE"] = "可以查看最近 %{limit} 次（共 %{total} 次）";
translations["MSG_BUILDER_COMPLETE_BTN"] = "完成！";
translations["MSG_BUILDER_INCOMPLETE_BTN"] = "还没完成";
translations["MSG_BUILDER_PUBLISH_SHARE_BTN"] = "公开给大家";
translations["MSG_BUILDER_KEEP_DRAFT_BTN"] = "继续制作";
translations["MSG_BUILDER_PUBLISH_HINT"] = "公开后\n其他人就能玩了";
translations["MSG_BUILDER_UNPUBLISH_HINT"] = "取消公开后\n其他人就不能玩了";
translations["MSG_BUILDER_TEST_SUCCESS_BACK_BTN"] = "返回编辑";
translations["MSG_BUILDER_PREVIEW_SUCCESS_BACK_BTN"] = "返回列表";
translations["MSG_BUILDER_PUBLISH_OPTION_COPY"] = "允许复制";
translations["MSG_BUILDER_PUBLISH_OPTION_COMMENT"] = "允许评论";
translations["MSG_BUILDER_PUBLISH_DENIED_TITLE"] = "需要家长许可";
translations["MSG_BUILDER_CREATE_DENIED_TITLE"] = "拼图只能做1个";
translations["MSG_BUILDER_CREATE_DENIED_MESSAGE"] =
  "还没有注册时，只能做1个拼图。\n想做更多，请先完成守护设置。";
translations["MSG_BUILDER_PUBLISH_DENIED_MESSAGE"] =
  "公开作品需要家长的许可。\n可以在家长页面进行设置。";
translations["MSG_BUILDER_COMPLETE_TOAST"] = "完成了！";
translations["MSG_BUILDER_COMPLETE_FAILED"] = "还有没完成的地方哦";
translations["MSG_BUILDER_LOAD_FAILED"] = "无法读取作品。";
translations["MSG_BUILDER_ACTION_FAILED"] = "操作失败了，请再试一次。";
// 拼图编辑器: 草稿编辑 (spec §5.8.7/§5.8.8)
translations["MSG_BUILDER_DRAFT_EDITING_PILL"] = "草稿编辑中";
translations["MSG_BUILDER_DISCARD_DRAFT_BTN"] = "舍弃草稿";
translations["MSG_BUILDER_DISCARD_DRAFT_CONFIRM"] = "要停止编辑吗？";
// 拼图编辑器: AIChatModal (spec §5.8.5)
translations["MSG_BUILDER_AI_CHAT_TITLE"] = "用AI制作";
translations["MSG_BUILDER_AI_CHAT_SUBTITLE"] = "通过对话制作地图";
translations["MSG_BUILDER_AI_GREETING"] = "要做什么样的地图？";
translations["MSG_BUILDER_AI_PLAN_LABEL"] = "方案 %{n}";
translations["MSG_BUILDER_AI_USE_THIS"] = "使用这个";
translations["MSG_BUILDER_AI_REGENERATE"] = "再来3个方案";
translations["MSG_BUILDER_AI_RECOMMENDED"] = "（推荐）";
translations["MSG_BUILDER_AI_SESSION_EXPIRED"] = "之前的对话消失了。我们从头再聊一次吧";
translations["MSG_BUILDER_AI_SEND_BTN"] = "发送";
translations["MSG_BUILDER_AI_INPUT_PLACEHOLDER"] = "写下更多指示";
translations["MSG_BUILDER_AI_COMMANDS_LABEL"] = "使用的命令";
translations["MSG_BUILDER_AI_FLOORS_LABEL"] = "高度";
translations["MSG_BUILDER_AI_FLOOR_UNIT"] = "层";
translations["MSG_BUILDER_AI_RESET"] = "重新开始";
// 拼图编辑器: BuilderTutorialOverlay (spec §5.8.6)
translations["MSG_BUILDER_TUTORIAL_STEP1_TITLE"] = "放置角色吧！";
translations["MSG_BUILDER_TUTORIAL_STEP1_DESC"] = "把下面的角色放到地图上";
translations["MSG_BUILDER_TUTORIAL_STEP2_TITLE"] = "放置终点吧！";
translations["MSG_BUILDER_TUTORIAL_STEP2_DESC"] = "接下来放置终点旗帜";
translations["MSG_BUILDER_TUTORIAL_STEP3_TITLE"] = "排列积木吧！";
translations["MSG_BUILDER_TUTORIAL_STEP3_DESC"] = "放置道路和植物来制作地图";
translations["MSG_BUILDER_TUTORIAL_STEP4_TITLE"] = "用测试动起来！";
translations["MSG_BUILDER_TUTORIAL_STEP4_DESC"] = "放好角色和终点后，就能用上方的测试来玩";
translations["MSG_BUILDER_GUIDE_REPLAY"] = "再看一次引导";
translations["MSG_BUILDER_TUTORIAL_STEP5_TITLE"] = "公开吧！";
translations["MSG_BUILDER_TUTORIAL_STEP5_DESC"] = "用“完成准备”面板公开吧";
translations["MSG_BUILDER_TUTORIAL_SKIP"] = "稍后查看";
translations["MSG_BUILDER_TUTORIAL_NEXT"] = "下一步";
translations["MSG_BUILDER_TUTORIAL_DONE"] = "开始";
translations["MSG_BUILDER_TOP_GUIDE_BTN"] = "使用方法";
translations["MSG_BUILDER_GUIDEBOOK_TITLE"] = "使用方法";
translations["MSG_BUILDER_GUIDEBOOK_PREV"] = "上一页";
translations["MSG_BUILDER_GUIDEBOOK_NEXT"] = "下一页";
translations["MSG_BUILDER_GUIDEBOOK_DONE"] = "关闭";
translations["MSG_BUILDER_GUIDEBOOK_PAGE"] = "%{current} / %{total}";
translations["MSG_BUILDER_GUIDEBOOK_CH_MINE"] = "我的拼图";
translations["MSG_BUILDER_GUIDEBOOK_CH_PUBLIC"] = "大家的拼图";
translations["MSG_BUILDER_GUIDEBOOK_CH_DETAIL"] = "拼图详情";
translations["MSG_BUILDER_GUIDEBOOK_CH_TRASH"] = "回收站";
translations["MSG_BUILDER_GUIDEBOOK_MINE_OVERVIEW_TITLE"] = "我的拼图页面";
translations["MSG_BUILDER_GUIDEBOOK_MINE_OVERVIEW_DESC"] =
  "你做的拼图都排列在这里\n左边可以改变查找方式\n右边可以切换到其他页面";
translations["MSG_BUILDER_GUIDEBOOK_MINE_GUIDE_TITLE"] = "使用方法卡片";
translations["MSG_BUILDER_GUIDEBOOK_MINE_GUIDE_DESC"] =
  "这是列表里的第一张卡片\n迷路时打开它，就会出现这本手册";
translations["MSG_BUILDER_GUIDEBOOK_MINE_CARD_TITLE"] = "拼图卡片";
translations["MSG_BUILDER_GUIDEBOOK_MINE_CARD_DESC"] =
  "一张卡片就是一个拼图\n上面是名字和作者\n中间是地图的样子";
translations["MSG_BUILDER_GUIDEBOOK_MINE_STATS_TITLE"] = "卡片上的数字";
translations["MSG_BUILDER_GUIDEBOOK_MINE_STATS_DESC"] =
  "从左边开始：被看的次数、点赞数\n然后是被玩的次数\n公开之后就会增加";
translations["MSG_BUILDER_GUIDEBOOK_MINE_ACTIONS_TITLE"] = "卡片的四个按钮";
translations["MSG_BUILDER_GUIDEBOOK_MINE_ACTIONS_DESC"] =
  "从左边开始：切换公开、玩一玩\n编辑、打开详情";
translations["MSG_BUILDER_GUIDEBOOK_MINE_FILTER_TITLE"] = "筛选";
translations["MSG_BUILDER_GUIDEBOOK_MINE_FILTER_DESC"] =
  "用「公开」可以只显示已公开的拼图\n「其他」可以按照用AI做的拼图等条件来筛选";
translations["MSG_BUILDER_GUIDEBOOK_MINE_SORT_TITLE"] = "排序与显示";
translations["MSG_BUILDER_GUIDEBOOK_MINE_SORT_DESC"] =
  "用排序改变顺序\n用显示选择一列还是两列\n做得多了以后会很方便";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TABS_TITLE"] = "右边的标签";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TABS_DESC"] = "点「大家的拼图」\n可以看到别人公开的拼图";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TRASH_TITLE"] = "去回收站";
translations["MSG_BUILDER_GUIDEBOOK_MINE_TRASH_DESC"] =
  "这个按钮可以查看丢掉的拼图\n不小心丢掉了，也可以从这里找回来";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_OVERVIEW_TITLE"] = "大家的拼图页面";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_OVERVIEW_DESC"] =
  "这里排列着别人公开的拼图\n可以随便玩，喜欢的话请点赞";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_ACTIONS_TITLE"] = "卡片的三个按钮";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_ACTIONS_DESC"] =
  "从左边开始：玩一玩、复制来做\n打开详情";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_FILTER_TITLE"] = "按种类筛选";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_FILTER_DESC"] =
  "用「种类」可以选择地图的类型\n想找自己喜欢的拼图时可以用";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_SORT_TITLE"] = "按人气排序";
translations["MSG_BUILDER_GUIDEBOOK_PUBLIC_SORT_DESC"] =
  "选择点赞后\n点赞多的拼图会排在前面\n也可以按最新排序";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OVERVIEW_TITLE"] = "详情页面";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OVERVIEW_DESC"] =
  "这里可以看到拼图的全部内容\n可以先确认是什么样的地图再玩";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_TABS_TITLE"] = "四个标签";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_TABS_DESC"] =
  "详情、指令、排行榜、评论\n点一下就能切换\n在指令里能看到可以使用的命令";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_INFO_TITLE"] = "名字与说明";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_INFO_DESC"] =
  "这是作者写的名字和说明\n下面的数字是被看的次数等";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REACTION_TITLE"] = "表情反应";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REACTION_DESC"] =
  "可以用这些图标表达玩过之后的感想\n点一下就会传给作者";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_EXPAND_TITLE"] = "展开";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_EXPAND_DESC"] =
  "说明很长时可以点这里\n被藏起来的部分也能全部读到";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_ACTIONS_TITLE"] = "下面的按钮";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_ACTIONS_DESC"] =
  "点玩一玩就能马上开始\n用复制来做可以变成自己的拼图";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REPORT_TITLE"] = "举报";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_REPORT_DESC"] =
  "如果看到让你不舒服的拼图\n请从这里告诉我们\n会有大人来确认";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OWN_TITLE"] = "自己的拼图时";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_OWN_DESC"] =
  "打开自己的拼图时，按钮会不一样\n可以「编辑」，也可以切换公开";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_CODE_TITLE"] = "拼图码";
translations["MSG_BUILDER_GUIDEBOOK_DETAIL_CODE_DESC"] =
  "这是这个拼图的暗号\n告诉朋友，他们就能找到同一个拼图";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_SEND_TITLE"] = "放进回收站";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_SEND_DESC"] =
  "不需要的拼图可以放进回收站\n从详情页面放进去\n并不会马上消失";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_OVERVIEW_TITLE"] = "回收站里面";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_OVERVIEW_DESC"] =
  "放进回收站的拼图会排列在这里\n还在这里的时候都可以找回来";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_RESTORE_TITLE"] = "还原或彻底删除";
translations["MSG_BUILDER_GUIDEBOOK_TRASH_RESTORE_DESC"] =
  "绿色按钮可以还原\n红色按钮会彻底删除\n删除后就找不回来了";
translations["MSG_BUILDER_GUIDEBOOK_CH_SCREEN"] = "画面说明";
translations["MSG_BUILDER_GUIDEBOOK_CH_BUILD"] = "制作地图";
translations["MSG_BUILDER_GUIDEBOOK_CH_SETTING"] = "拼图设置";
translations["MSG_BUILDER_GUIDEBOOK_CH_PUBLISH"] = "测试与公开";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_OVERVIEW_TITLE"] = "编辑画面";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_OVERVIEW_DESC"] =
  "在中间制作地图\n周围有四个区域\n各有各的作用";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_HEADER_TITLE"] = "上面的工具栏";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_HEADER_DESC"] =
  "左边是拼图的名字\n右边是详情、大小、指令\n自动生成、测试、帮助";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_STEPS_TITLE"] = "左边的面板";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_STEPS_DESC"] =
  "这里列出了公开之前要做的事\n按顺序完成后，最后就可以公开了";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_TOOLS_TITLE"] = "右边的工具";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_TOOLS_DESC"] =
  "做错了可以撤销\n改变方块的放置方式\n改变地图的显示方式";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_ASSETS_TITLE"] = "下面的工具栏";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_ASSETS_DESC"] =
  "这里排列着可以放置的方块和角色\n从这里选好后放到地图上";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_BACK_TITLE"] = "返回";
translations["MSG_BUILDER_GUIDEBOOK_SCREEN_BACK_DESC"] =
  "回到拼图列表\n做好的内容会自动保存\n请放心";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_BLOCKS_TITLE"] = "选择并放置";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_BLOCKS_DESC"] =
  "在下面的工具栏选择方块\n点地图就能放置\n同样的方块可以放很多个";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_OPEN_TITLE"] = "打开列表";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_OPEN_DESC"] =
  "这个按钮在下面工具栏的最右边\n按一下就能看到所有可以使用的方块";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_LIST_TITLE"] = "全部方块";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_LIST_DESC"] =
  "点「列表」就能看到所有可以使用的方块\n地面、水等每种类型都有说明";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_TAP_TITLE"] = "放置与橡皮";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_TAP_DESC"] =
  "「点击」是放置模式，「橡皮」是删除模式\n想删除时先切换到橡皮再点";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_UNDO_TITLE"] = "撤销与重做";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_UNDO_DESC"] =
  "做错了也没关系\n用撤销回到上一步\n用重做再往前一步";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_ZOOM_TITLE"] = "改变视角";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_ZOOM_DESC"] =
  "用缩小、放大改变地图的大小\n用重置把角度和大小恢复原样";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_HISTORY_TITLE"] = "修改记录";
translations["MSG_BUILDER_GUIDEBOOK_BUILD_HISTORY_DESC"] =
  "你做过的操作会按顺序保留下来\n想找出哪里做错了的时候很方便";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_STEPS_TITLE"] = "完成准备";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_STEPS_DESC"] =
  "公开之前有5件事要做\n完成的会打上绿色的勾";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_CHARACTER_TITLE"] = "角色与终点";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_CHARACTER_DESC"] =
  "放一个出发的角色\n放一个要到达的终点\n缺了任何一个都不能测试";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_COMMANDS_TITLE"] = "可用的指令";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_COMMANDS_DESC"] =
  "选择玩的人可以使用的命令\n也可以设定次数\n次数越少地图越难";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_SIZE_TITLE"] = "地图大小";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_SIZE_DESC"] =
  "可以改变地图的大小\n变大之后能放更多东西\n不过难度也会提高";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_AI_TITLE"] = "让AI来做";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_AI_DESC"] =
  "先选好难度\nAI会给出几个地图方案\n挑一个喜欢的再自己修改";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_INFO_TITLE"] = "拼图信息";
translations["MSG_BUILDER_GUIDEBOOK_SETTING_INFO_DESC"] =
  "在这里决定名字、说明和封面图\n这是玩的人最先看到的地方";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_TEST_TITLE"] = "测试";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_TEST_DESC"] =
  "这个按钮可以玩自己的地图来确认\n通不了关的地图不能公开";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PLAY_TITLE"] = "测试画面";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PLAY_DESC"] =
  "这和玩的人看到的画面一样\n在这里确认能不能到达终点";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_COMMANDS_TITLE"] = "排列指令";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_COMMANDS_DESC"] =
  "把左边的命令拖出来连起来\n「剩余」表示还能用几次";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_START_TITLE"] = "开始";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_START_DESC"] =
  "角色会按照排好的指令行动\n到达终点就算通关";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_STEP_TITLE"] = "测试步骤";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_STEP_DESC"] =
  "通过测试后，这里会打上勾\n修改地图之后需要重新测试";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PUBLISH_TITLE"] = "向大家公开";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_PUBLISH_DESC"] =
  "5项准备全部完成后就能按了\n公开之后，拼图会出现在大家的拼图里";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_HELP_TITLE"] = "遇到困难就看帮助";
translations["MSG_BUILDER_GUIDEBOOK_PUBLISH_HELP_DESC"] =
  "随时都可以打开这本手册\n每个画面也有各自的帮助\n只说明那个地方";
translations["MSG_BUILDER_TOP_GUIDE_CLOSE"] = "关闭";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP1_TITLE"] = "我的拼图";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP1_DESC"] = "这里会显示你自己制作的拼图。";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP2_TITLE"] = "打开拼图";
translations["MSG_BUILDER_TOP_GUIDE_MINE_STEP2_DESC"] = "点击卡片即可查看拼图的详细内容。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP1_TITLE"] = "大家的拼图";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP1_DESC"] = "可以玩其他人公开的拼图。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP2_TITLE"] = "寻找拼图";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_STEP2_DESC"] = "点击卡片，找到你喜欢的拼图。";
translations["MSG_BUILDER_TOP_GUIDE_TRASH_STEP1_TITLE"] = "垃圾箱";
translations["MSG_BUILDER_TOP_GUIDE_TRASH_STEP1_DESC"] = "删除的拼图会放在这里。也可以还原。";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP1_TITLE"] = "拼图信息";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP1_DESC"] =
  "用上方的应用代码，可以把拼图分享给朋友。";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP2_TITLE"] = "编辑与公开";
translations["MSG_BUILDER_TOP_GUIDE_MINE_DETAIL_STEP2_DESC"] = "可以在这里修改拼图，或公开给大家。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP1_TITLE"] = "玩这个拼图";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP1_DESC"] = "可以查看其他人拼图的内容。";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP2_TITLE"] = "收藏与举报";
translations["MSG_BUILDER_TOP_GUIDE_PUBLIC_DETAIL_STEP2_DESC"] = "喜欢就点爱心，有问题可以举报。";
translations["MSG_BUILDER_COMMAND_BTN"] = "命令";
translations["MSG_BUILDER_HELP_BTN"] = "帮助";
// ピースビルダー: 画面ごとのヘルプ説明（BuilderHelpPopup）
translations["MSG_BUILDER_HELP_AI_TITLE"] = "用AI制作";
translations["MSG_BUILDER_HELP_ASSET_TITLE"] = "选择方块";
translations["MSG_BUILDER_HELP_HISTORY_TITLE"] = "修改记录";
translations["MSG_BUILDER_STEP_NEED_GROUND"] = "需要先放置地面";
translations["MSG_BUILDER_COMMENT_GUEST"] = "完成监护设置后\n就可以评论";
translations["MSG_BUILDER_COMMENT_BLOCKED"] = "家长把评论关掉了";
translations["MSG_BUILDER_COMMENT_OFF"] = "这个拼图的评论是关着的";
translations["MSG_BUILDER_COMMENT_UNPUBLISHED"] = "公开后就可以收到评论";
translations["MSG_BUILDER_COMMENT_DENIED"] = "现在不能评论";
translations["MSG_BUILDER_COMMENT_BANNED_WORD"] = "里面有不能使用的词语，请重新写一次";
translations["MSG_BUILDER_STEP_PLACE_GROUND_FIRST"] = "请先放置地面";
translations["MSG_BUILDER_PLACE_ON_GROUND"] = "请放在地面上";
translations["MSG_BUILDER_PLACE_ON_TILE"] = "请放在地图的方格上";
translations["MSG_BUILDER_ONLY_ONE_CHARACTER"] = "角色只能放一个";
translations["MSG_BUILDER_ONLY_ONE_GOAL"] = "终点只能放一个";
translations["MSG_BUILDER_HELP_PUBLISH_GROUND_TITLE"] = "先放地面";
translations["MSG_BUILDER_HELP_PUBLISH_GROUND_DESC"] =
  "角色和终点要放在地面上\n没有地面就放不了\n按「放置」就能选地面";
translations["MSG_BUILDER_HELP_PUBLISH_TITLE"] = "发布你的拼图";
translations["MSG_BUILDER_HELP_DETAIL_TABS_TITLE"] = "四个标签";
translations["MSG_BUILDER_HELP_DETAIL_TABS_DESC"] = "详情、指令、排行榜、评论\n点一下切换";
translations["MSG_BUILDER_HELP_DETAIL_NAME_TITLE"] = "名称与说明";
translations["MSG_BUILDER_HELP_DETAIL_NAME_DESC"] = "用「修改」编辑\n这是玩的人最先看到的地方";
translations["MSG_BUILDER_HELP_DETAIL_COVER_TITLE"] = "封面与背景";
translations["MSG_BUILDER_HELP_DETAIL_COVER_DESC"] = "封面：列表里显示的图\n背景：玩的时候的景色";
translations["MSG_BUILDER_HELP_AI_LEVEL_TITLE"] = "难度";
translations["MSG_BUILDER_HELP_AI_LEVEL_DESC"] = "星星越多越难";
translations["MSG_BUILDER_HELP_AI_FLOOR_TITLE"] = "高度";
translations["MSG_BUILDER_HELP_AI_FLOOR_DESC"] = "地图的层数\n层数越多越立体";
translations["MSG_BUILDER_HELP_AI_CREATE_TITLE"] = "生成";
translations["MSG_BUILDER_HELP_AI_CREATE_DESC"] =
  "会生成3个方案\n点一下可以放大确认\n可以反复重新生成";
translations["MSG_BUILDER_HELP_ASSET_ALL_TITLE"] = "方块一览";
translations["MSG_BUILDER_HELP_ASSET_ALL_DESC"] = "所有可以使用的方块";
translations["MSG_BUILDER_HELP_ASSET_KIND_TITLE"] = "种类";
translations["MSG_BUILDER_HELP_ASSET_KIND_DESC"] = "地面、水、装饰、道具\n按种类分组";
translations["MSG_BUILDER_HELP_ASSET_PICK_TITLE"] = "选择并放置";
translations["MSG_BUILDER_HELP_ASSET_PICK_DESC"] = "点一下选择\n再点地图就能放置";
translations["MSG_BUILDER_HELP_HISTORY_ALL_TITLE"] = "修改记录";
translations["MSG_BUILDER_HELP_HISTORY_ALL_DESC"] = "做过的操作按最新顺序排列";
translations["MSG_BUILDER_HELP_HISTORY_ITEM_TITLE"] = "一条记录";
translations["MSG_BUILDER_HELP_HISTORY_ITEM_DESC"] = "做了什么，以及当时的时间";
translations["MSG_BUILDER_HELP_HISTORY_UNDO_TITLE"] = "还原";
translations["MSG_BUILDER_HELP_HISTORY_UNDO_DESC"] = "可以恢复到当时的地图\n恢复之后还能继续做";
translations["MSG_BUILDER_HELP_PUBLISH_STEPS_TITLE"] = "完成准备";
translations["MSG_BUILDER_HELP_PUBLISH_STEPS_DESC"] = "公开之前要做的5件事";
translations["MSG_BUILDER_HELP_PUBLISH_CHECK_TITLE"] = "打勾";
translations["MSG_BUILDER_HELP_PUBLISH_CHECK_DESC"] = "完成后会打上绿色的勾";
translations["MSG_BUILDER_HELP_PUBLISH_GO_TITLE"] = "向大家公开";
translations["MSG_BUILDER_HELP_PUBLISH_GO_DESC"] = "5项都完成后就能按\n会出现在大家的拼图里";
translations["MSG_BUILDER_HELP_DETAIL_TITLE"] = "拼图信息";
translations["MSG_BUILDER_SIZE_MODAL_TITLE"] = "选择大小";
translations["MSG_BUILDER_SIZE_SHRINK_WARNING"] = "缩小后，超出范围的%{count}个会被删除";
// 拼图编辑器: PiecePreview (spec §5.7)
translations["MSG_BUILDER_PREVIEW_RUN"] = "执行";
translations["MSG_BUILDER_PREVIEW_RESET"] = "重置";
translations["MSG_BUILDER_PREVIEW_MOVES"] = "步数";
translations["MSG_BUILDER_PREVIEW_TIME"] = "时间";
translations["MSG_BUILDER_PREVIEW_BLOCK_DISABLED"] = "这个拼图里不能用哦";
translations["MSG_BUILDER_PREVIEW_CLEAR"] = "通关！";
translations["MSG_BUILDER_PREVIEW_BACK"] = "退出";
translations["MSG_BUILDER_SAVED"] = "已保存";
translations["MSG_CHAT_NEW_BADGE"] = "New";
translations["MSG_CHAT_LOAD_MORE"] = "查看更多";
translations["MSG_DASHBOARD_MAIL_EMPTY"] = "还没有邮件";
translations["MSG_DASHBOARD_MAIL_IMAGE"] = "照片";
translations["MSG_DASHBOARD_MAIL_PROJECT"] = "项目";
translations["MSG_DASHBOARD_MAIL_COURSE_CLEAR"] = "课程通关";

translations["MSG_CHAT_SEND_FAILED_MESSAGE"] = "发送消息失败";

translations["MSG_CREATOR_DEFAULT_CHECK_APP"] = "查看\n应用";
translations["MSG_CREATOR_DEFAULT_CREATE_APP"] = "创建应用";
translations["MSG_CREATOR_DEFAULT_SEARCH_APP"] = "搜索应用";

translations["MSG_SUBSCRIPTION_ASK_PARENT_BTN"] = "请家长帮忙";
translations["MSG_SUBSCRIPTION_ASK_PARENT_SENT_LABEL"] = "已发送";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_TITLE"] = "请家长帮忙";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_WITH_PLAN"] = "要向家长请求「%{plan}」吗？";
translations["MSG_SUBSCRIPTION_ASK_PARENT_MODAL_MESSAGE_NO_PLAN"] = "要向家长发送方案请求吗？";
translations["MSG_SUBSCRIPTION_ASK_PARENT_SEND_BTN"] = "发送";
translations["MSG_SUBSCRIPTION_ASK_PARENT_CANCEL_BTN"] = "取消";
translations["MSG_SUBSCRIPTION_ASK_PARENT_TOAST_SUCCESS"] = "已发送请求。";
translations["MSG_SUBSCRIPTION_ASK_PARENT_TOAST_ERROR"] = "发送失败。请重试。";
translations["MSG_SUBSCRIPTION_REQUEST_CARD_CHILD_STATUS"] = "已向家长发送方案请求。";

export default translations;
